// AUTO-GENERATED: UI translations for the Jazz Nights flow. es = source of truth.
// Generated from the i18n workflow; refine wording centrally here if needed.
import type { Lang } from "@/stores/lang";

export const translations: Record<Lang, Record<string, string>> = {
  "es": {
    "pagar.title": "Tu reserva",
    "survey.title": "Tu opinión",
    "survey.notFound": "Esta encuesta no está disponible. Si crees que es un error, contacta con el local.",
    "survey.intro": "¿Qué te pareció nuestra Jazz Night?",
    "survey.thanks": "¡Gracias! Tu opinión nos ayuda muchísimo a cuidar cada noche.",
    "survey.q.global": "Experiencia completa",
    "survey.q.music": "La música",
    "survey.q.food": "La comida",
    "survey.q.service": "El servicio",
    "survey.q.recommend": "¿Nos recomendarías?",
    "survey.q.frequency": "¿Con qué frecuencia nos visitas?",
    "survey.q.comment": "¿Algo más que quieras contarnos? (opcional)",
    "survey.freq.first_time": "Es mi primera vez",
    "survey.freq.sometimes": "De forma puntual",
    "survey.freq.monthly": "Una vez al mes",
    "survey.freq.weekly": "Una vez a la semana",
    "survey.comment.placeholder": "Lo que más te gustó, lo que mejoraríamos…",
    "survey.error": "No se pudo enviar. Inténtalo de nuevo en un momento.",
    "survey.send": "Enviar",
    "survey.sending": "Enviando…",
    "survey.footer": "Gracias por acompañarnos.",
    "tablepicker.discount.title": "Entradas limitadas",
    "landing.promo.dates": "10-18 Julio",
    "landing.promo.headline": "Hasta -45%",
    "landing.promo.sub": "En entradas",
    "pagar.notFound": "No encontramos esta reserva. Comprueba el enlace o contacta con el local.",
    "pagar.confirmed.body": "Esta reserva ya está confirmada. ¡Nos vemos pronto!",
    "pagar.confirmed.btn": "Ver tu reserva",
    "pagar.unavailable": "Esta reserva ya no está disponible. Si crees que es un error, contacta con el local.",
    "pagar.intro": "Completa el pago para confirmar tu reserva. La mesa queda reservada a tu nombre mientras tanto.",
    "pagar.label.session": "Sesión",
    "pagar.label.artist": "Artista",
    "pagar.label.table": "Mesa",
    "pagar.label.people": "Personas",
    "pagar.label.menu": "Menú",
    "pagar.label.total": "Total",
    "pagar.error": "No se pudo iniciar el pago. Inténtalo de nuevo o contacta con el local.",
    "pagar.pay": "Pagar {total}",
    "pagar.paying": "Redirigiendo al pago…",
    "pagar.secure": "Pago seguro con tarjeta a través de Redsys.",
    "modsesion.step.session": "Elige una sesión",
    "modsesion.noSessions": "No hay otras sesiones disponibles.",
    "modsesion.full": "Completa",
    "modsesion.currentSession": "Esta es tu sesión actual",
    "modmenu.heading": "Elige tu menú",
    "modmenu.cheaperNote": "No disponible",
    "modmenu.continue": "Continuar",
    "modmenu.diffNote": "Diferencia por elegir un menú más caro que el actual.",
    "modsesion.step.table": "Elige tu mesa",
    "modsesion.step.review": "Revisa el cambio",
    "modsesion.newSession": "Nueva sesión",
    "modsesion.newTable": "Nueva mesa",
    "modsesion.toPay": "A abonar",
    "modsesion.diffNote": "Diferencia por elegir una mesa más cara que la actual.",
    "modsesion.noCost": "Cambio sin coste adicional",
    "modsesion.pay": "Pagar diferencia",
    "modsesion.confirm": "Confirmar cambio",
    "modsesion.paySoon": "El pago de la diferencia estará disponible muy pronto.",
    "modsesion.error": "No se pudo cambiar la sesión. Inténtalo de nuevo.",
    "modsesion.done.title": "Reserva modificada",
    "modsesion.done.body": "Tu reserva ha sido modificada con éxito.",
    "modsesion.done.emailNote": "Te hemos enviado un email de confirmación con tu nueva reserva.",
    "modsesion.summary.title": "Resumen de tu nueva reserva",
    "modsesion.summary.people": "Personas",
    "modsesion.summary.date": "Fecha",
    "modsesion.summary.time": "Hora",
    "modsesion.summary.table": "Mesa",
    "modsesion.summary.menu": "Menú",
    "modsesion.summary.newTotal": "Nuevo total",
    "common.loading": "Cargando…",
    "common.person_one": "{count} persona",
    "common.person_other": "{count} personas",
    "manage.title": "Gestiona tu reserva",
    "manage.btn.session": "Modificar sesión",
    "manage.btn.menu": "Ver/modificar menú",
    "manage.btn.addGuests": "Añadir asistentes",
    "addguests.heading": "¿Cuántos asistentes quieres añadir?",
    "addguests.current": "Tu reserva actual es para {people}",
    "addguests.willAdd": "Vas a añadir",
    "addguests.platos.heading": "Elige los platos de los nuevos asistentes",
    "addguests.noFit": "En tu mesa actual no caben {total} personas.",
    "addguests.noFitAction": "Selecciona otra mesa disponible",
    "addguests.noTables": "No hay mesas disponibles para esa cantidad de asistentes, lo sentimos.",
    "addguests.newTable": "Nueva mesa: {tier}",
    "addguests.mesa": "Mesa",
    "addguests.diffNote": "Entrada y menú de los asistentes añadidos.",
    "addguests.confirmPay": "Confirmar y pagar",
    "addguests.original": "Reserva original",
    "addguests.modified": "Nueva reserva",
    "addguests.soon": "Configuraremos los platos y el pago de los nuevos asistentes en el siguiente paso.",
    "manage.btn.cancel": "Cancelar reserva",
    "manage.notFound": "No encontramos tu reserva. Revisa el enlace de tu email.",
    "modify.soon.session": "Estamos preparando esta opción. Muy pronto podrás cambiar tu sesión desde aquí.",
    "modify.soon.menu": "Estamos preparando esta opción. Muy pronto podrás cambiar tu menú desde aquí.",
    "modify.back": "← Volver",
    "cancelar.title": "Cancelar reserva",
    "cancelar.cancelled.label": "Reserva cancelada",
    "cancelar.cancelled.refund": "Tu reserva ha sido cancelada. Te reembolsaremos {amount} al método de pago original (puede tardar unos días hábiles en reflejarse).",
    "cancelar.cancelled.noRefund": "Tu reserva ha sido cancelada.",
    "cancelar.details": "Detalles de tu reserva",
    "cancelar.label.persons": "Personas",
    "cancelar.label.date": "Fecha",
    "cancelar.label.time": "Hora sesión",
    "cancelar.label.ticket": "Entrada concierto",
    "cancelar.label.menu": "Menú",
    "cancelar.label.artist": "Artista",
    "cancelar.label.paid": "Pagado",
    "cancelar.perPerson": "/ persona",
    "cancelar.totalRefund": "Total a reembolsar",
    "cancelar.noRefund": "Sin reembolso",
    "cancelar.reason.full": "Entrada + menú",
    "cancelar.reason.menuOnly": "Solo el menú · la entrada no es reembolsable",
    "cancelar.noRefundNote": "Puedes cancelar igualmente para liberar tu mesa, pero según la política de cancelación (menos de 24 h antes de la sesión) no hay reembolso.",
    "cancelar.error.generic": "No se pudo cancelar la reserva. Inténtalo de nuevo más tarde.",
    "cancelar.confirm": "Confirmar cancelación",
    "cancelar.confirming": "Cancelando…",
    "cancelar.policy.title": "Política cancelación",
    "cancelar.cantCancel.title": "Esta reserva no se puede cancelar online.",
    "cancelar.cantCancel.notPaid": "La reserva no consta como pagada.",
    "cancelar.cantCancel.past": "La sesión ya ha comenzado o ha pasado. Contacta con el restaurante.",
    "cancelar.notFound": "No encontramos la reserva.",
    "landing.hero.price": "Desde 5€ + Cena",
    "landing.hero.subtitle": "Escucha Jazz en directo y cena\nen nuestro club en el Manhattan\nde los años veinte.",
    "landing.hero.cta": "Descubre la programación",
    "landing.info.sessions": "SESIONES",
    "landing.info.sessions.value": "19:00 - 21:00 - 23:00",
    "landing.info.duration": "DURACIÓN",
    "landing.info.duration.value": "1h 45 min",
    "landing.info.includes": "INCLUYE",
    "landing.info.includes.value": "Concierto + Menú",
    "landing.button.reserve": "Reserva Jazz Nights",
    "landing.programming.title": "Programación",
    "landing.programming.artist.pending": "Por confirmar",
    "landing.programming.photo.placeholder": "— foto —",
    "landing.howitworks.title": "Cómo funciona",
    "landing.howitworks.step1.title": "ELIGE SESIÓN",
    "landing.howitworks.step1.description": "Selecciona la hora que prefieras entre nuestras tres sesiones.",
    "landing.howitworks.step2.title": "ESCOGE UBICACIÓN",
    "landing.howitworks.step2.description": "Elige tu zona preferida para vivir tu experiencia.",
    "landing.howitworks.step3.title": "SELECCIONA TU MENÚ",
    "landing.howitworks.step3.description": "Descubre la propuesta gastronómica que hemos creado.",
    "landing.howitworks.step4.title": "DISFRUTA LA NOCHE",
    "landing.howitworks.step4.description": "Déjate llevar por el jazz, la gastronomía y la magia de los años veinte.",
    "sesiones.personas.heading": "¿Cuántas personas sois?",
    "sesiones.personas.btn_remove_aria": "Quitar una persona",
    "sesiones.personas.btn_add_aria": "Añadir una persona",
    "sesiones.personas.btn_continue": "Continúa",
    "sesiones.fecha.heading": "Elige la fecha",
    "sesiones.fecha.loading": "Cargando programación…",
    "sesiones.fecha.empty_state": "Todavía no hay sesiones programadas. Vuelve pronto.",
    "sesiones.fecha.event_title": "Jazz Night en Manhattan",
    "sesiones.fecha.event_description": "Escucha Jazz en directo y cena en nuestro club en el Manhattan de los años veinte.",
    "sesiones.fecha.event_price": "Entrada desde 5€ + cena",
    "sesiones.fecha.btn_back": "‹ Volver",
    "sesiones.fecha.btn_continue": "Continúa",
    "sesiones.hora.heading": "Selecciona la hora de la sesión",
    "sesiones.hora.subtitle": "Selecciona la hora que prefieras entre nuestras tres sesiones.",
    "sesiones.hora.session_type": "Concierto + cena",
    "sesiones.hora.event_price": "Entrada desde 5€ + cena",
    "sesiones.hora.btn_back": "‹ Volver",
    "sesiones.hora.btn_continue": "Continúa",
    "ubicacion.breadcrumb.personas": "{n} personas",
    "ubicacion.heading.title": "Elige tu ubicación",
    "ubicacion.heading.subtitle": "El precio de la entrada depende de la zona seleccionada. Las mesas grises no están disponibles.",
    "ubicacion.loading.message": "Cargando plano…",
    "ubicacion.back.button": "‹ Volver",
    "ubicacion.cta.loading": "Reservando…",
    "ubicacion.cta.ready": "Continúa",
    "ubicacion.modal.title": "Antes de continuar",
    "ubicacion.modal.description": "Has escogido una mesa en el patio, estas mesas se encuentran detrás del escenario así que la visibilidad del concierto puede ser limitada o nula.",
    "ubicacion.modal.confirm_button": "Sí, continúa",
    "ubicacion.modal.confirm_loading": "Reservando…",
    "ubicacion.modal.cancel_button": "Quiero elegir otra",
    "menu.step_heading": "Selecciona tu menú",
    "menu.step_subtitle": "La experiencia Jazz Nights incluye entrada y menú de cena para todos los asistentes.",
    "menu.error_invalid": "Selecciona un menú válido",
    "menu.loading": "Cargando…",
    "menu.price_per_person": "€ / persona",
    "menu.course_mandatory": "Obligatorio",
    "menu.course_shared": "A compartir",
    "menu.course_drink_variant": "Bebida + cocktail",
    "menu.course_label_entrantes": "Entrantes",
    "menu.course_label_principal": "Principal",
    "menu.course_label_postres": "Postres",
    "menu.course_label_bebida": "Bebida",
    "menu.course_instruction_principal": "Elige 1 principal por persona",
    "menu.course_instruction_postre": "Elige 1 postre por persona",
    "menu.button_remove": "Quitar {name}",
    "menu.button_add": "Añadir {name}",
    "menu.button_selected": "Menú seleccionado",
    "menu.button_choose": "Elige el {name}",
    "menu.button_back": "‹ Volver",
    "menu.button_continue": "Continúa al pago",
    "menu.error_incomplete_courses": "Elige {seats} {course} en total (llevas {current})",
    "menu.error_save_failed": "No se pudo guardar el menú",
    "menu.breadcrumb_party_size": "{n} personas",
    "pago.loading.label": "Cargando reserva…",
    "pago.revisar.heading": "REVISA QUE TODO ESTÉ CORRECTO",
    "pago.revisar.summary.personas": "Personas",
    "pago.revisar.summary.fecha": "Fecha",
    "pago.revisar.summary.hora_sesion": "Hora sesión",
    "pago.revisar.summary.entrada_concierto": "Entrada concierto",
    "pago.revisar.summary.entrada_valor": "{price} / persona",
    "pago.revisar.summary.menu": "Menú",
    "pago.revisar.summary.menu_valor": "{name} · {price} / persona",
    "pago.revisar.summary.principales": "Principales",
    "pago.revisar.summary.postres": "Postres",
    "pago.revisar.recomendacion": "Te recomendamos llegar entre 15 y 30 minutos antes del inicio de la experiencia",
    "pago.revisar.cta": "Confirma la información",
    "pago.confirmed.heading": "RESERVA CONFIRMADA!",
    "pago.confirmed.demo_note": "Modo demo — el pago real se activa en producción.",
    "pago.contacto.heading": "POR ÚLTIMO NECESITAMOS TU CONTACTO",
    "pago.contacto.seccion_datos.titulo": "Datos de contacto",
    "pago.contacto.form.nombre_placeholder": "Nombre y apellidos*",
    "pago.contacto.form.email_placeholder": "Email*",
    "pago.contacto.form.telefono_placeholder": "Teléfono*",
    "pago.contacto.form.comentarios_placeholder": "Comentarios o alergias",
    "pago.contacto.seccion_condiciones.titulo": "Condiciones",
    "pago.contacto.condiciones.experiencia": "He leído que la experiencia incluye entrada y cena",
    "pago.contacto.condiciones.politicas": "Acepto el Tratamiento de Datos, Política de Privacidad y Política de Cancelación",
    "pago.contacto.condiciones.politicas_parte1": "Acepto el ",
    "pago.contacto.condiciones.politicas_parte2": "Tratamiento de Datos",
    "pago.contacto.condiciones.politicas_parte3": ", ",
    "pago.contacto.condiciones.politicas_parte4": "Política de Privacidad",
    "pago.contacto.condiciones.politicas_parte5": " y ",
    "pago.contacto.condiciones.politicas_parte6": "Política de Cancelación",
    "pago.contacto.condiciones.comunicaciones": "Consiento la recepción de comunicaciones del restaurante por e-mail y/o SMS con fines comerciales.",
    "pago.contacto.recomendacion": "Te recomendamos llegar entre 15 y 30 minutos antes del inicio de la experiencia",
    "pago.contacto.seccion_total.titulo": "Total de la reserva",
    "pago.contacto.total.entrada": "Entrada",
    "pago.contacto.total.entrada_subtexto": "{price} × {n}",
    "pago.contacto.total.menu": "Menú",
    "pago.contacto.total.menu_subtexto": "{price} × {n}",
    "pago.contacto.total.total": "Total",
    "pago.contacto.error_completos": "Completa nombre, email y teléfono para continuar.",
    "pago.contacto.error_condiciones": "Debes aceptar las condiciones para continuar.",
    "pago.contacto.error_pago": "Error iniciando el pago",
    "pago.contacto.volver": "‹ Volver",
    "pago.contacto.cta": "Continuar al pago",
    "pago.checkout.procesando": "Procesando…",
    "pago.checkout.cta": "Pagar",
    "pago.checkout.error_generico": "Error en el pago",
    "politicaCancelacion.titulo": "Política de cancelación",
    "politicaCancelacion.contenido.encabezado": "Cancelaciones y modificaciones",
    "politicaCancelacion.contenido.regla1": "Más de 48h antes de la sesión: cancelación gratuita y reembolso íntegro (entrada + menú).",
    "politicaCancelacion.contenido.regla2": "Entre 48h y 24h antes: se reembolsa el menú; la entrada al concierto no es reembolsable.",
    "politicaCancelacion.contenido.regla3": "Menos de 24h antes o no presentación: sin reembolso.",
    "politicaCancelacion.contenido.cambiosFecha": "Cambios de fecha sin coste hasta 48h antes de la sesión, sujetos a disponibilidad.",
    "politicaCancelacion.boton.volver": "‹ Volver",
    "confirmacion.error.notFound": "Reserva no encontrada.",
    "confirmacion.loading": "Cargando confirmación…",
    "confirmacion.processing.label": "Procesando pago",
    "confirmacion.processing.title": "Estamos confirmando tu reserva",
    "confirmacion.processing.message": "Esto suele tardar unos segundos. No cierres esta página.",
    "confirmacion.failed.label": "Pago no completado",
    "confirmacion.failed.title": "No hemos podido confirmar tu reserva",
    "confirmacion.failed.message": "Si crees que es un error, contacta con el restaurante con tu referencia: {referenceId}",
    "confirmacion.success.label": "Reserva confirmada",
    "confirmacion.success.title": "Te esperamos el sábado",
    "confirmacion.details.label": "Detalles",
    "confirmacion.details.artist": "Artista",
    "confirmacion.details.people": "Personas",
    "confirmacion.details.totalPaid": "Total pagado",
    "confirmacion.details.reference": "Referencia",
    "confirmacion.dishes.label": "Platos elegidos",
    "confirmacion.dishes.principal": "Principal",
    "confirmacion.dishes.postre": "Postre",
    "confirmacion.ticket.label": "Tu entrada",
    "confirmacion.ticket.qrAlt": "QR de tu reserva",
    "confirmacion.ticket.instructions": "Presenta este QR en la entrada el día del espectáculo.",
    "confirmacion.email.sent": "Te hemos enviado los detalles a {email}.",
    "layout.header.logo.aria_label": "Voltereta — inicio",
    "layout.footer.logo.aria_label": "Voltereta — inicio",
    "wizard.header.title": "Reserva tu Jazz Night",
    "tablepicker.zone.salon": "Sala principal",
    "tablepicker.zone.patio": "Patio",
    "tablepicker.table.tooltip": "Mesa {number} · {capacity} pax · {price} entrada",
    "tablepicker.backdrop.escenario": "ESCENARIO",
    "tablepicker.backdrop.tras_escenario": "TRAS EL ESCENARIO",
    "stepper.progress_label": "Progreso de la reserva",
    "ubicacion.error.loading_tables": "Error cargando mesas",
    "ubicacion.error.reserve_failed": "No se pudo reservar la mesa",
    "ubicacion.breadcrumb.table_prefix": "mesa"
  },
  "gb": {
    "pagar.title": "Your booking",
    "survey.title": "Your feedback",
    "survey.notFound": "This survey isn't available. If you think this is a mistake, contact the venue.",
    "survey.intro": "How was our Jazz Night?",
    "survey.thanks": "Thank you! Your feedback helps us make every night better.",
    "survey.q.global": "The full experience",
    "survey.q.music": "The music",
    "survey.q.food": "The food",
    "survey.q.service": "The service",
    "survey.q.recommend": "Would you recommend us?",
    "survey.q.frequency": "How often do you visit us?",
    "survey.q.comment": "Anything else you'd like to tell us? (optional)",
    "survey.freq.first_time": "It's my first time",
    "survey.freq.sometimes": "Now and then",
    "survey.freq.monthly": "Once a month",
    "survey.freq.weekly": "Once a week",
    "survey.comment.placeholder": "What you loved, what we could improve…",
    "survey.error": "Couldn't send it. Please try again in a moment.",
    "survey.send": "Send",
    "survey.sending": "Sending…",
    "survey.footer": "Thanks for joining us.",
    "tablepicker.discount.title": "Limited tickets",
    "landing.promo.dates": "10-18 July",
    "landing.promo.headline": "Up to -45%",
    "landing.promo.sub": "On tickets",
    "pagar.notFound": "We couldn't find this booking. Check the link or contact the venue.",
    "pagar.confirmed.body": "This booking is already confirmed. See you soon!",
    "pagar.confirmed.btn": "View your booking",
    "pagar.unavailable": "This booking is no longer available. If you think this is a mistake, contact the venue.",
    "pagar.intro": "Complete the payment to confirm your booking. Your table is held in the meantime.",
    "pagar.label.session": "Session",
    "pagar.label.artist": "Artist",
    "pagar.label.table": "Table",
    "pagar.label.people": "Guests",
    "pagar.label.menu": "Menu",
    "pagar.label.total": "Total",
    "pagar.error": "We couldn't start the payment. Try again or contact the venue.",
    "pagar.pay": "Pay {total}",
    "pagar.paying": "Redirecting to payment…",
    "pagar.secure": "Secure card payment via Redsys.",
    "modsesion.step.session": "Choose a session",
    "modsesion.noSessions": "There are no other sessions available.",
    "modsesion.full": "Full",
    "modsesion.currentSession": "This is your current session",
    "modmenu.heading": "Choose your menu",
    "modmenu.cheaperNote": "Not available",
    "modmenu.continue": "Continue",
    "modmenu.diffNote": "Difference for choosing a menu pricier than your current one.",
    "modsesion.step.table": "Choose your table",
    "modsesion.step.review": "Review the change",
    "modsesion.newSession": "New session",
    "modsesion.newTable": "New table",
    "modsesion.toPay": "To pay",
    "modsesion.diffNote": "Difference for choosing a table pricier than your current one.",
    "modsesion.noCost": "Change at no extra cost",
    "modsesion.pay": "Pay difference",
    "modsesion.confirm": "Confirm change",
    "modsesion.paySoon": "Paying the difference will be available very soon.",
    "modsesion.error": "We couldn't change the session. Please try again.",
    "modsesion.done.title": "Booking modified",
    "modsesion.done.body": "Your booking has been modified successfully.",
    "modsesion.done.emailNote": "We've sent you a confirmation email with your new booking.",
    "modsesion.summary.title": "Summary of your new booking",
    "modsesion.summary.people": "Guests",
    "modsesion.summary.date": "Date",
    "modsesion.summary.time": "Time",
    "modsesion.summary.table": "Table",
    "modsesion.summary.menu": "Menu",
    "modsesion.summary.newTotal": "New total",
    "common.loading": "Loading…",
    "common.person_one": "{count} person",
    "common.person_other": "{count} people",
    "manage.title": "Manage your booking",
    "manage.btn.session": "Change session",
    "manage.btn.menu": "View/change menu",
    "manage.btn.addGuests": "Add guests",
    "addguests.heading": "How many guests do you want to add?",
    "addguests.current": "Your booking is currently for {people}",
    "addguests.willAdd": "You're adding",
    "addguests.platos.heading": "Choose the dishes for the new guests",
    "addguests.noFit": "Your current table can't fit {total} guests.",
    "addguests.noFitAction": "Select another available table",
    "addguests.noTables": "There are no tables available for that number of guests, we're sorry.",
    "addguests.newTable": "New table: {tier}",
    "addguests.mesa": "Table",
    "addguests.diffNote": "Entry and menu for the added guests.",
    "addguests.confirmPay": "Confirm and pay",
    "addguests.original": "Original booking",
    "addguests.modified": "New booking",
    "addguests.soon": "We'll set up the dishes and payment for the new guests in the next step.",
    "manage.btn.cancel": "Cancel booking",
    "manage.notFound": "We couldn't find your booking. Check the link in your email.",
    "modify.soon.session": "We're getting this option ready. Soon you'll be able to change your session here.",
    "modify.soon.menu": "We're getting this option ready. Soon you'll be able to change your menu here.",
    "modify.back": "← Back",
    "cancelar.title": "Cancel booking",
    "cancelar.cancelled.label": "Booking cancelled",
    "cancelar.cancelled.refund": "Your booking has been cancelled. We'll refund {amount} to your original payment method (it may take a few business days to show up).",
    "cancelar.cancelled.noRefund": "Your booking has been cancelled.",
    "cancelar.details": "Your booking details",
    "cancelar.label.persons": "Guests",
    "cancelar.label.date": "Date",
    "cancelar.label.time": "Session time",
    "cancelar.label.ticket": "Concert ticket",
    "cancelar.label.menu": "Menu",
    "cancelar.label.artist": "Artist",
    "cancelar.label.paid": "Paid",
    "cancelar.perPerson": "/ person",
    "cancelar.totalRefund": "Total refund",
    "cancelar.noRefund": "No refund",
    "cancelar.reason.full": "Ticket + menu",
    "cancelar.reason.menuOnly": "Menu only · the ticket is non-refundable",
    "cancelar.noRefundNote": "You can still cancel to free up your table, but under the cancellation policy (less than 24 h before the session) there is no refund.",
    "cancelar.error.generic": "We couldn't cancel the booking. Please try again later.",
    "cancelar.confirm": "Confirm cancellation",
    "cancelar.confirming": "Cancelling…",
    "cancelar.policy.title": "Cancellation policy",
    "cancelar.cantCancel.title": "This booking can't be cancelled online.",
    "cancelar.cantCancel.notPaid": "The booking is not marked as paid.",
    "cancelar.cantCancel.past": "The session has already started or passed. Please contact the restaurant.",
    "cancelar.notFound": "We couldn't find the booking.",
    "landing.hero.price": "From €5 + Dinner",
    "landing.hero.subtitle": "Listen to live Jazz and dine\nat our club in 1920s\nManhattan.",
    "landing.hero.cta": "Discover the line-up",
    "landing.info.sessions": "SESSIONS",
    "landing.info.sessions.value": "19:00 - 21:00 - 23:00",
    "landing.info.duration": "DURATION",
    "landing.info.duration.value": "1h 45 min",
    "landing.info.includes": "INCLUDES",
    "landing.info.includes.value": "Concert + Menu",
    "landing.button.reserve": "Book Jazz Nights",
    "landing.programming.title": "Line-up",
    "landing.programming.artist.pending": "To be confirmed",
    "landing.programming.photo.placeholder": "— photo —",
    "landing.howitworks.title": "How it works",
    "landing.howitworks.step1.title": "CHOOSE A SESSION",
    "landing.howitworks.step1.description": "Pick the time that suits you best from our three sessions.",
    "landing.howitworks.step2.title": "CHOOSE YOUR SPOT",
    "landing.howitworks.step2.description": "Select your favourite area to enjoy your experience.",
    "landing.howitworks.step3.title": "SELECT YOUR MENU",
    "landing.howitworks.step3.description": "Discover the dining experience we have created.",
    "landing.howitworks.step4.title": "ENJOY THE NIGHT",
    "landing.howitworks.step4.description": "Let yourself be swept away by the jazz, the food and the magic of the twenties.",
    "sesiones.personas.heading": "How many of you are coming?",
    "sesiones.personas.btn_remove_aria": "Remove a guest",
    "sesiones.personas.btn_add_aria": "Add a guest",
    "sesiones.personas.btn_continue": "Continue",
    "sesiones.fecha.heading": "Choose the date",
    "sesiones.fecha.loading": "Loading line-up…",
    "sesiones.fecha.empty_state": "No sessions scheduled yet. Check back soon.",
    "sesiones.fecha.event_title": "Jazz Night in Manhattan",
    "sesiones.fecha.event_description": "Listen to live Jazz and dine at our club in 1920s Manhattan.",
    "sesiones.fecha.event_price": "Entry from €5 + dinner",
    "sesiones.fecha.btn_back": "‹ Back",
    "sesiones.fecha.btn_continue": "Continue",
    "sesiones.hora.heading": "Select the session time",
    "sesiones.hora.subtitle": "Pick the time that suits you best from our three sessions.",
    "sesiones.hora.session_type": "Concert + dinner",
    "sesiones.hora.event_price": "Entry from €5 + dinner",
    "sesiones.hora.btn_back": "‹ Back",
    "sesiones.hora.btn_continue": "Continue",
    "ubicacion.breadcrumb.personas": "{n} guests",
    "ubicacion.heading.title": "Choose your spot",
    "ubicacion.heading.subtitle": "The entry price depends on the area selected. Tables shown in grey are not available.",
    "ubicacion.loading.message": "Loading the floor plan…",
    "ubicacion.back.button": "‹ Back",
    "ubicacion.cta.loading": "Booking…",
    "ubicacion.cta.ready": "Continue",
    "ubicacion.modal.title": "Before you continue",
    "ubicacion.modal.description": "You have chosen a table on the patio. These tables sit behind the stage, so the view of the concert may be limited or obstructed.",
    "ubicacion.modal.confirm_button": "Yes, continue",
    "ubicacion.modal.confirm_loading": "Booking…",
    "ubicacion.modal.cancel_button": "I'd rather choose another",
    "menu.step_heading": "Select your menu",
    "menu.step_subtitle": "The Jazz Nights experience includes entry and a dinner menu for every guest.",
    "menu.error_invalid": "Please select a valid menu",
    "menu.loading": "Loading…",
    "menu.price_per_person": "€ / person",
    "menu.course_mandatory": "Required",
    "menu.course_shared": "To share",
    "menu.course_drink_variant": "Drink + cocktail",
    "menu.course_label_entrantes": "Starters",
    "menu.course_label_principal": "Mains",
    "menu.course_label_postres": "Desserts",
    "menu.course_label_bebida": "Drink",
    "menu.course_instruction_principal": "Choose 1 main per person",
    "menu.course_instruction_postre": "Choose 1 dessert per person",
    "menu.button_remove": "Remove {name}",
    "menu.button_add": "Add {name}",
    "menu.button_selected": "Menu selected",
    "menu.button_choose": "Choose the {name}",
    "menu.button_back": "‹ Back",
    "menu.button_continue": "Continue to payment",
    "menu.error_incomplete_courses": "Choose {seats} {course} in total (you have {current})",
    "menu.error_save_failed": "The menu could not be saved",
    "menu.breadcrumb_party_size": "{n} guests",
    "pago.loading.label": "Loading booking…",
    "pago.revisar.heading": "CHECK THAT EVERYTHING IS CORRECT",
    "pago.revisar.summary.personas": "Guests",
    "pago.revisar.summary.fecha": "Date",
    "pago.revisar.summary.hora_sesion": "Session time",
    "pago.revisar.summary.entrada_concierto": "Concert entry",
    "pago.revisar.summary.entrada_valor": "{price} / person",
    "pago.revisar.summary.menu": "Menu",
    "pago.revisar.summary.menu_valor": "{name} · {price} / person",
    "pago.revisar.summary.principales": "Mains",
    "pago.revisar.summary.postres": "Desserts",
    "pago.revisar.recomendacion": "We recommend arriving between 15 and 30 minutes before the experience begins",
    "pago.revisar.cta": "Confirm the details",
    "pago.confirmed.heading": "BOOKING CONFIRMED!",
    "pago.confirmed.demo_note": "Demo mode — real payment is enabled in production.",
    "pago.contacto.heading": "FINALLY, WE NEED YOUR CONTACT DETAILS",
    "pago.contacto.seccion_datos.titulo": "Contact details",
    "pago.contacto.form.nombre_placeholder": "Full name*",
    "pago.contacto.form.email_placeholder": "Email*",
    "pago.contacto.form.telefono_placeholder": "Phone*",
    "pago.contacto.form.comentarios_placeholder": "Comments or allergies",
    "pago.contacto.seccion_condiciones.titulo": "Terms",
    "pago.contacto.condiciones.experiencia": "I have read that the experience includes entry and dinner",
    "pago.contacto.condiciones.politicas": "I accept the Data Processing terms, Privacy Policy and Cancellation Policy",
    "pago.contacto.condiciones.politicas_parte1": "I accept the ",
    "pago.contacto.condiciones.politicas_parte2": "Data Processing terms",
    "pago.contacto.condiciones.politicas_parte3": ", ",
    "pago.contacto.condiciones.politicas_parte4": "Privacy Policy",
    "pago.contacto.condiciones.politicas_parte5": " and ",
    "pago.contacto.condiciones.politicas_parte6": "Cancellation Policy",
    "pago.contacto.condiciones.comunicaciones": "I consent to receiving communications from the restaurant by email and/or SMS for marketing purposes.",
    "pago.contacto.recomendacion": "We recommend arriving between 15 and 30 minutes before the experience begins",
    "pago.contacto.seccion_total.titulo": "Booking total",
    "pago.contacto.total.entrada": "Entry",
    "pago.contacto.total.entrada_subtexto": "{price} × {n}",
    "pago.contacto.total.menu": "Menu",
    "pago.contacto.total.menu_subtexto": "{price} × {n}",
    "pago.contacto.total.total": "Total",
    "pago.contacto.error_completos": "Please complete your name, email and phone to continue.",
    "pago.contacto.error_condiciones": "You must accept the terms to continue.",
    "pago.contacto.error_pago": "Error starting the payment",
    "pago.contacto.volver": "‹ Back",
    "pago.contacto.cta": "Continue to payment",
    "pago.checkout.procesando": "Processing…",
    "pago.checkout.cta": "Pay",
    "pago.checkout.error_generico": "Payment error",
    "politicaCancelacion.titulo": "Cancellation Policy",
    "politicaCancelacion.contenido.encabezado": "Cancellations and changes",
    "politicaCancelacion.contenido.regla1": "More than 48h before the session: free cancellation and full refund (entry + menu).",
    "politicaCancelacion.contenido.regla2": "Between 48h and 24h before: the menu is refunded; the concert entry is non-refundable.",
    "politicaCancelacion.contenido.regla3": "Less than 24h before or no-show: no refund.",
    "politicaCancelacion.contenido.cambiosFecha": "Date changes free of charge up to 48h before the session, subject to availability.",
    "politicaCancelacion.boton.volver": "‹ Back",
    "confirmacion.error.notFound": "Booking not found.",
    "confirmacion.loading": "Loading confirmation…",
    "confirmacion.processing.label": "Processing payment",
    "confirmacion.processing.title": "We're confirming your booking",
    "confirmacion.processing.message": "This usually takes a few seconds. Please don't close this page.",
    "confirmacion.failed.label": "Payment not completed",
    "confirmacion.failed.title": "We couldn't confirm your booking",
    "confirmacion.failed.message": "If you think this is a mistake, contact the restaurant with your reference: {referenceId}",
    "confirmacion.success.label": "Booking confirmed",
    "confirmacion.success.title": "We look forward to seeing you on Saturday",
    "confirmacion.details.label": "Details",
    "confirmacion.details.artist": "Artist",
    "confirmacion.details.people": "Guests",
    "confirmacion.details.totalPaid": "Total paid",
    "confirmacion.details.reference": "Reference",
    "confirmacion.dishes.label": "Dishes chosen",
    "confirmacion.dishes.principal": "Main",
    "confirmacion.dishes.postre": "Dessert",
    "confirmacion.ticket.label": "Your ticket",
    "confirmacion.ticket.qrAlt": "QR code for your booking",
    "confirmacion.ticket.instructions": "Show this QR code at the entrance on the day of the show.",
    "confirmacion.email.sent": "We've sent the details to {email}.",
    "layout.header.logo.aria_label": "Voltereta — home",
    "layout.footer.logo.aria_label": "Voltereta — home",
    "wizard.header.title": "Book your Jazz Night",
    "tablepicker.zone.salon": "Main hall",
    "tablepicker.zone.patio": "Patio",
    "tablepicker.table.tooltip": "Table {number} · {capacity} pax · {price} entry",
    "tablepicker.backdrop.escenario": "STAGE",
    "tablepicker.backdrop.tras_escenario": "BEHIND THE STAGE",
    "stepper.progress_label": "Booking progress",
    "ubicacion.error.loading_tables": "Error loading tables",
    "ubicacion.error.reserve_failed": "Could not reserve the table",
    "ubicacion.breadcrumb.table_prefix": "table"
  },
  "de": {
    "pagar.title": "Deine Reservierung",
    "survey.title": "Deine Meinung",
    "survey.notFound": "Diese Umfrage ist nicht verfügbar. Wenn du glaubst, dass das ein Fehler ist, kontaktiere das Lokal.",
    "survey.intro": "Wie war unsere Jazz Night?",
    "survey.thanks": "Danke! Deine Meinung hilft uns, jeden Abend besser zu machen.",
    "survey.q.global": "Das gesamte Erlebnis",
    "survey.q.music": "Die Musik",
    "survey.q.food": "Das Essen",
    "survey.q.service": "Der Service",
    "survey.q.recommend": "Würdest du uns weiterempfehlen?",
    "survey.q.frequency": "Wie oft besuchst du uns?",
    "survey.q.comment": "Möchtest du uns noch etwas sagen? (optional)",
    "survey.freq.first_time": "Das erste Mal",
    "survey.freq.sometimes": "Ab und zu",
    "survey.freq.monthly": "Einmal im Monat",
    "survey.freq.weekly": "Einmal pro Woche",
    "survey.comment.placeholder": "Was dir gefallen hat, was wir verbessern könnten…",
    "survey.error": "Konnte nicht gesendet werden. Bitte versuche es gleich noch einmal.",
    "survey.send": "Senden",
    "survey.sending": "Senden…",
    "survey.footer": "Danke, dass du dabei warst.",
    "tablepicker.discount.title": "Begrenzte Tickets",
    "landing.promo.dates": "10.-18. Juli",
    "landing.promo.headline": "Bis zu -45%",
    "landing.promo.sub": "Auf Tickets",
    "pagar.notFound": "Wir konnten diese Reservierung nicht finden. Überprüfe den Link oder kontaktiere das Lokal.",
    "pagar.confirmed.body": "Diese Reservierung ist bereits bestätigt. Bis bald!",
    "pagar.confirmed.btn": "Reservierung ansehen",
    "pagar.unavailable": "Diese Reservierung ist nicht mehr verfügbar. Wenn du glaubst, dass das ein Fehler ist, kontaktiere das Lokal.",
    "pagar.intro": "Schließe die Zahlung ab, um deine Reservierung zu bestätigen. Dein Tisch bleibt währenddessen reserviert.",
    "pagar.label.session": "Session",
    "pagar.label.artist": "Künstler",
    "pagar.label.table": "Tisch",
    "pagar.label.people": "Personen",
    "pagar.label.menu": "Menü",
    "pagar.label.total": "Gesamt",
    "pagar.error": "Die Zahlung konnte nicht gestartet werden. Versuche es erneut oder kontaktiere das Lokal.",
    "pagar.pay": "{total} bezahlen",
    "pagar.paying": "Weiterleitung zur Zahlung…",
    "pagar.secure": "Sichere Kartenzahlung über Redsys.",
    "modsesion.step.session": "Wähle eine Session",
    "modsesion.noSessions": "Es sind keine anderen Sessions verfügbar.",
    "modsesion.full": "Ausgebucht",
    "modsesion.currentSession": "Das ist deine aktuelle Session",
    "modmenu.heading": "Wähle dein Menü",
    "modmenu.cheaperNote": "Nicht verfügbar",
    "modmenu.continue": "Weiter",
    "modmenu.diffNote": "Differenz, weil du ein teureres Menü als bisher gewählt hast.",
    "modsesion.step.table": "Wähle deinen Tisch",
    "modsesion.step.review": "Änderung prüfen",
    "modsesion.newSession": "Neue Session",
    "modsesion.newTable": "Neuer Tisch",
    "modsesion.toPay": "Zu zahlen",
    "modsesion.diffNote": "Differenz, weil du einen teureren Tisch als bisher gewählt hast.",
    "modsesion.noCost": "Änderung ohne Aufpreis",
    "modsesion.pay": "Differenz zahlen",
    "modsesion.confirm": "Änderung bestätigen",
    "modsesion.paySoon": "Die Zahlung der Differenz ist bald verfügbar.",
    "modsesion.error": "Die Session konnte nicht geändert werden. Bitte versuche es erneut.",
    "modsesion.done.title": "Reservierung geändert",
    "modsesion.done.body": "Deine Reservierung wurde erfolgreich geändert.",
    "modsesion.done.emailNote": "Wir haben dir eine Bestätigungs-E-Mail mit deiner neuen Reservierung gesendet.",
    "modsesion.summary.title": "Übersicht deiner neuen Reservierung",
    "modsesion.summary.people": "Personen",
    "modsesion.summary.date": "Datum",
    "modsesion.summary.time": "Uhrzeit",
    "modsesion.summary.table": "Tisch",
    "modsesion.summary.menu": "Menü",
    "modsesion.summary.newTotal": "Neue Summe",
    "common.loading": "Wird geladen…",
    "common.person_one": "{count} Person",
    "common.person_other": "{count} Personen",
    "manage.title": "Verwalte deine Reservierung",
    "manage.btn.session": "Session ändern",
    "manage.btn.menu": "Menü ansehen/ändern",
    "manage.btn.addGuests": "Gäste hinzufügen",
    "addguests.heading": "Wie viele Gäste möchtest du hinzufügen?",
    "addguests.current": "Deine Reservierung ist aktuell für {people}",
    "addguests.willAdd": "Du fügst hinzu",
    "addguests.platos.heading": "Wähle die Gerichte für die neuen Gäste",
    "addguests.noFit": "An deinem aktuellen Tisch ist kein Platz für {total} Personen.",
    "addguests.noFitAction": "Wähle einen anderen verfügbaren Tisch",
    "addguests.noTables": "Für diese Anzahl an Gästen sind keine Tische verfügbar, es tut uns leid.",
    "addguests.newTable": "Neuer Tisch: {tier}",
    "addguests.mesa": "Tisch",
    "addguests.diffNote": "Eintritt und Menü der hinzugefügten Gäste.",
    "addguests.confirmPay": "Bestätigen und bezahlen",
    "addguests.original": "Ursprüngliche Reservierung",
    "addguests.modified": "Neue Reservierung",
    "addguests.soon": "Im nächsten Schritt richten wir Gerichte und Zahlung für die neuen Gäste ein.",
    "manage.btn.cancel": "Reservierung stornieren",
    "manage.notFound": "Wir konnten deine Reservierung nicht finden. Prüfe den Link in deiner E-Mail.",
    "modify.soon.session": "Wir bereiten diese Option vor. Bald kannst du hier deine Session ändern.",
    "modify.soon.menu": "Wir bereiten diese Option vor. Bald kannst du hier dein Menü ändern.",
    "modify.back": "← Zurück",
    "cancelar.title": "Reservierung stornieren",
    "cancelar.cancelled.label": "Reservierung storniert",
    "cancelar.cancelled.refund": "Deine Reservierung wurde storniert. Wir erstatten {amount} auf dein ursprüngliches Zahlungsmittel zurück (es kann einige Werktage dauern, bis es sichtbar ist).",
    "cancelar.cancelled.noRefund": "Deine Reservierung wurde storniert.",
    "cancelar.details": "Deine Reservierungsdetails",
    "cancelar.label.persons": "Personen",
    "cancelar.label.date": "Datum",
    "cancelar.label.time": "Uhrzeit der Session",
    "cancelar.label.ticket": "Konzertticket",
    "cancelar.label.menu": "Menü",
    "cancelar.label.artist": "Künstler",
    "cancelar.label.paid": "Bezahlt",
    "cancelar.perPerson": "/ Person",
    "cancelar.totalRefund": "Erstattungsbetrag",
    "cancelar.noRefund": "Keine Erstattung",
    "cancelar.reason.full": "Ticket + Menü",
    "cancelar.reason.menuOnly": "Nur das Menü · das Ticket ist nicht erstattungsfähig",
    "cancelar.noRefundNote": "Du kannst trotzdem stornieren, um deinen Tisch freizugeben, aber laut Stornierungsbedingungen (weniger als 24 Std. vor der Session) gibt es keine Erstattung.",
    "cancelar.error.generic": "Die Reservierung konnte nicht storniert werden. Bitte versuche es später erneut.",
    "cancelar.confirm": "Stornierung bestätigen",
    "cancelar.confirming": "Wird storniert…",
    "cancelar.policy.title": "Stornierungsbedingungen",
    "cancelar.cantCancel.title": "Diese Reservierung kann nicht online storniert werden.",
    "cancelar.cantCancel.notPaid": "Die Reservierung ist nicht als bezahlt vermerkt.",
    "cancelar.cantCancel.past": "Die Session hat bereits begonnen oder ist vorbei. Bitte kontaktiere das Restaurant.",
    "cancelar.notFound": "Wir konnten die Reservierung nicht finden.",
    "landing.hero.price": "Ab 5€ + Abendessen",
    "landing.hero.subtitle": "Hören Sie Live-Jazz und genießen Sie ein Abendessen\nin unserem Club im Manhattan\nder zwanziger Jahre.",
    "landing.hero.cta": "Entdecken Sie das Programm",
    "landing.info.sessions": "SESSIONS",
    "landing.info.sessions.value": "19:00 - 21:00 - 23:00",
    "landing.info.duration": "DAUER",
    "landing.info.duration.value": "1 Std. 45 Min.",
    "landing.info.includes": "INKLUSIVE",
    "landing.info.includes.value": "Konzert + Menü",
    "landing.button.reserve": "Jazz Nights reservieren",
    "landing.programming.title": "Programm",
    "landing.programming.artist.pending": "Noch zu bestätigen",
    "landing.programming.photo.placeholder": "— Foto —",
    "landing.howitworks.title": "So funktioniert es",
    "landing.howitworks.step1.title": "SESSION WÄHLEN",
    "landing.howitworks.step1.description": "Wählen Sie die gewünschte Uhrzeit aus unseren drei Sessions.",
    "landing.howitworks.step2.title": "PLATZ WÄHLEN",
    "landing.howitworks.step2.description": "Wählen Sie Ihren bevorzugten Bereich für Ihr Erlebnis.",
    "landing.howitworks.step3.title": "MENÜ AUSWÄHLEN",
    "landing.howitworks.step3.description": "Entdecken Sie das kulinarische Angebot, das wir für Sie kreiert haben.",
    "landing.howitworks.step4.title": "DIE NACHT GENIESSEN",
    "landing.howitworks.step4.description": "Lassen Sie sich vom Jazz, der Gastronomie und dem Zauber der zwanziger Jahre verzaubern.",
    "sesiones.personas.heading": "Wie viele Personen sind Sie?",
    "sesiones.personas.btn_remove_aria": "Eine Person entfernen",
    "sesiones.personas.btn_add_aria": "Eine Person hinzufügen",
    "sesiones.personas.btn_continue": "Weiter",
    "sesiones.fecha.heading": "Wählen Sie das Datum",
    "sesiones.fecha.loading": "Programm wird geladen…",
    "sesiones.fecha.empty_state": "Es sind noch keine Sessions geplant. Schauen Sie bald wieder vorbei.",
    "sesiones.fecha.event_title": "Jazz Night in Manhattan",
    "sesiones.fecha.event_description": "Hören Sie Live-Jazz und genießen Sie ein Abendessen in unserem Club im Manhattan der zwanziger Jahre.",
    "sesiones.fecha.event_price": "Eintritt ab 5€ + Abendessen",
    "sesiones.fecha.btn_back": "‹ Zurück",
    "sesiones.fecha.btn_continue": "Weiter",
    "sesiones.hora.heading": "Wählen Sie die Uhrzeit der Session",
    "sesiones.hora.subtitle": "Wählen Sie die gewünschte Uhrzeit aus unseren drei Sessions.",
    "sesiones.hora.session_type": "Konzert + Abendessen",
    "sesiones.hora.event_price": "Eintritt ab 5€ + Abendessen",
    "sesiones.hora.btn_back": "‹ Zurück",
    "sesiones.hora.btn_continue": "Weiter",
    "ubicacion.breadcrumb.personas": "{n} Personen",
    "ubicacion.heading.title": "Wählen Sie Ihren Platz",
    "ubicacion.heading.subtitle": "Der Eintrittspreis hängt vom ausgewählten Bereich ab. Die grauen Tische sind nicht verfügbar.",
    "ubicacion.loading.message": "Saalplan wird geladen…",
    "ubicacion.back.button": "‹ Zurück",
    "ubicacion.cta.loading": "Wird reserviert…",
    "ubicacion.cta.ready": "Weiter",
    "ubicacion.modal.title": "Bevor Sie fortfahren",
    "ubicacion.modal.description": "Sie haben einen Tisch im Innenhof gewählt. Diese Tische befinden sich hinter der Bühne, sodass die Sicht auf das Konzert eingeschränkt oder nicht vorhanden sein kann.",
    "ubicacion.modal.confirm_button": "Ja, weiter",
    "ubicacion.modal.confirm_loading": "Wird reserviert…",
    "ubicacion.modal.cancel_button": "Ich möchte einen anderen wählen",
    "menu.step_heading": "Wählen Sie Ihr Menü",
    "menu.step_subtitle": "Das Jazz Nights-Erlebnis umfasst Eintritt und Abendmenü für alle Gäste.",
    "menu.error_invalid": "Wählen Sie ein gültiges Menü",
    "menu.loading": "Wird geladen…",
    "menu.price_per_person": "€ / Person",
    "menu.course_mandatory": "Obligatorisch",
    "menu.course_shared": "Zum Teilen",
    "menu.course_drink_variant": "Getränk + Cocktail",
    "menu.course_label_entrantes": "Vorspeisen",
    "menu.course_label_principal": "Hauptgang",
    "menu.course_label_postres": "Desserts",
    "menu.course_label_bebida": "Getränk",
    "menu.course_instruction_principal": "Wählen Sie 1 Hauptgang pro Person",
    "menu.course_instruction_postre": "Wählen Sie 1 Dessert pro Person",
    "menu.button_remove": "{name} entfernen",
    "menu.button_add": "{name} hinzufügen",
    "menu.button_selected": "Menü ausgewählt",
    "menu.button_choose": "{name} wählen",
    "menu.button_back": "‹ Zurück",
    "menu.button_continue": "Weiter zur Zahlung",
    "menu.error_incomplete_courses": "Wählen Sie insgesamt {seats} {course} (aktuell {current})",
    "menu.error_save_failed": "Das Menü konnte nicht gespeichert werden",
    "menu.breadcrumb_party_size": "{n} Personen",
    "pago.loading.label": "Reservierung wird geladen…",
    "pago.revisar.heading": "PRÜFEN SIE, OB ALLES KORREKT IST",
    "pago.revisar.summary.personas": "Personen",
    "pago.revisar.summary.fecha": "Datum",
    "pago.revisar.summary.hora_sesion": "Uhrzeit der Session",
    "pago.revisar.summary.entrada_concierto": "Konzerteintritt",
    "pago.revisar.summary.entrada_valor": "{price} / Person",
    "pago.revisar.summary.menu": "Menü",
    "pago.revisar.summary.menu_valor": "{name} · {price} / Person",
    "pago.revisar.summary.principales": "Hauptgänge",
    "pago.revisar.summary.postres": "Desserts",
    "pago.revisar.recomendacion": "Wir empfehlen, 15 bis 30 Minuten vor Beginn des Erlebnisses einzutreffen",
    "pago.revisar.cta": "Angaben bestätigen",
    "pago.confirmed.heading": "RESERVIERUNG BESTÄTIGT!",
    "pago.confirmed.demo_note": "Demo-Modus — die echte Zahlung wird in der Produktion aktiviert.",
    "pago.contacto.heading": "ZULETZT BENÖTIGEN WIR IHRE KONTAKTDATEN",
    "pago.contacto.seccion_datos.titulo": "Kontaktdaten",
    "pago.contacto.form.nombre_placeholder": "Vor- und Nachname*",
    "pago.contacto.form.email_placeholder": "E-Mail*",
    "pago.contacto.form.telefono_placeholder": "Telefon*",
    "pago.contacto.form.comentarios_placeholder": "Anmerkungen oder Allergien",
    "pago.contacto.seccion_condiciones.titulo": "Bedingungen",
    "pago.contacto.condiciones.experiencia": "Ich habe gelesen, dass das Erlebnis Eintritt und Abendessen umfasst",
    "pago.contacto.condiciones.politicas": "Ich akzeptiere die Datenverarbeitung, die Datenschutzrichtlinie und die Stornierungsrichtlinie",
    "pago.contacto.condiciones.politicas_parte1": "Ich akzeptiere die ",
    "pago.contacto.condiciones.politicas_parte2": "Datenverarbeitung",
    "pago.contacto.condiciones.politicas_parte3": ", ",
    "pago.contacto.condiciones.politicas_parte4": "Datenschutzrichtlinie",
    "pago.contacto.condiciones.politicas_parte5": " und ",
    "pago.contacto.condiciones.politicas_parte6": "Stornierungsrichtlinie",
    "pago.contacto.condiciones.comunicaciones": "Ich willige in den Erhalt von Mitteilungen des Restaurants per E-Mail und/oder SMS zu Werbezwecken ein.",
    "pago.contacto.recomendacion": "Wir empfehlen, 15 bis 30 Minuten vor Beginn des Erlebnisses einzutreffen",
    "pago.contacto.seccion_total.titulo": "Gesamtbetrag der Reservierung",
    "pago.contacto.total.entrada": "Eintritt",
    "pago.contacto.total.entrada_subtexto": "{price} × {n}",
    "pago.contacto.total.menu": "Menü",
    "pago.contacto.total.menu_subtexto": "{price} × {n}",
    "pago.contacto.total.total": "Gesamt",
    "pago.contacto.error_completos": "Geben Sie Name, E-Mail und Telefon an, um fortzufahren.",
    "pago.contacto.error_condiciones": "Sie müssen die Bedingungen akzeptieren, um fortzufahren.",
    "pago.contacto.error_pago": "Fehler beim Starten der Zahlung",
    "pago.contacto.volver": "‹ Zurück",
    "pago.contacto.cta": "Weiter zur Zahlung",
    "pago.checkout.procesando": "Wird verarbeitet…",
    "pago.checkout.cta": "Bezahlen",
    "pago.checkout.error_generico": "Fehler bei der Zahlung",
    "politicaCancelacion.titulo": "Stornierungsrichtlinie",
    "politicaCancelacion.contenido.encabezado": "Stornierungen und Änderungen",
    "politicaCancelacion.contenido.regla1": "Mehr als 48 Std. vor der Session: kostenlose Stornierung und vollständige Rückerstattung (Eintritt + Menü).",
    "politicaCancelacion.contenido.regla2": "Zwischen 48 Std. und 24 Std. vorher: Das Menü wird erstattet; der Konzerteintritt ist nicht erstattungsfähig.",
    "politicaCancelacion.contenido.regla3": "Weniger als 24 Std. vorher oder Nichterscheinen: keine Rückerstattung.",
    "politicaCancelacion.contenido.cambiosFecha": "Kostenlose Terminänderungen bis 48 Std. vor der Session, vorbehaltlich der Verfügbarkeit.",
    "politicaCancelacion.boton.volver": "‹ Zurück",
    "confirmacion.error.notFound": "Reservierung nicht gefunden.",
    "confirmacion.loading": "Bestätigung wird geladen…",
    "confirmacion.processing.label": "Zahlung wird verarbeitet",
    "confirmacion.processing.title": "Wir bestätigen gerade Ihre Reservierung",
    "confirmacion.processing.message": "Dies dauert in der Regel nur wenige Sekunden. Schließen Sie diese Seite nicht.",
    "confirmacion.failed.label": "Zahlung nicht abgeschlossen",
    "confirmacion.failed.title": "Wir konnten Ihre Reservierung nicht bestätigen",
    "confirmacion.failed.message": "Wenn Sie glauben, dass es sich um einen Fehler handelt, kontaktieren Sie das Restaurant mit Ihrer Referenz: {referenceId}",
    "confirmacion.success.label": "Reservierung bestätigt",
    "confirmacion.success.title": "Wir erwarten Sie am Samstag",
    "confirmacion.details.label": "Details",
    "confirmacion.details.artist": "Künstler",
    "confirmacion.details.people": "Personen",
    "confirmacion.details.totalPaid": "Gesamt bezahlt",
    "confirmacion.details.reference": "Referenz",
    "confirmacion.dishes.label": "Gewählte Gerichte",
    "confirmacion.dishes.principal": "Hauptgang",
    "confirmacion.dishes.postre": "Dessert",
    "confirmacion.ticket.label": "Ihr Ticket",
    "confirmacion.ticket.qrAlt": "QR-Code Ihrer Reservierung",
    "confirmacion.ticket.instructions": "Zeigen Sie diesen QR-Code am Eingang am Tag der Veranstaltung vor.",
    "confirmacion.email.sent": "Wir haben Ihnen die Details an {email} gesendet.",
    "layout.header.logo.aria_label": "Voltereta — Startseite",
    "layout.footer.logo.aria_label": "Voltereta — Startseite",
    "wizard.header.title": "Reservieren Sie Ihre Jazz Night",
    "tablepicker.zone.salon": "Hauptsaal",
    "tablepicker.zone.patio": "Innenhof",
    "tablepicker.table.tooltip": "Tisch {number} · {capacity} Pers. · {price} Eintritt",
    "tablepicker.backdrop.escenario": "BÜHNE",
    "tablepicker.backdrop.tras_escenario": "HINTER DER BÜHNE",
    "stepper.progress_label": "Fortschritt der Reservierung",
    "ubicacion.error.loading_tables": "Fehler beim Laden der Tische",
    "ubicacion.error.reserve_failed": "Der Tisch konnte nicht reserviert werden",
    "ubicacion.breadcrumb.table_prefix": "Tisch"
  },
  "fr": {
    "pagar.title": "Votre réservation",
    "survey.title": "Votre avis",
    "survey.notFound": "Ce questionnaire n'est pas disponible. Si vous pensez qu'il s'agit d'une erreur, contactez l'établissement.",
    "survey.intro": "Comment s'est passée notre Jazz Night ?",
    "survey.thanks": "Merci ! Votre avis nous aide à rendre chaque soirée meilleure.",
    "survey.q.global": "L'expérience complète",
    "survey.q.music": "La musique",
    "survey.q.food": "La cuisine",
    "survey.q.service": "Le service",
    "survey.q.recommend": "Nous recommanderiez-vous ?",
    "survey.q.frequency": "À quelle fréquence nous rendez-vous visite ?",
    "survey.q.comment": "Quelque chose d'autre à nous dire ? (facultatif)",
    "survey.freq.first_time": "C'est ma première fois",
    "survey.freq.sometimes": "De temps en temps",
    "survey.freq.monthly": "Une fois par mois",
    "survey.freq.weekly": "Une fois par semaine",
    "survey.comment.placeholder": "Ce que vous avez aimé, ce que nous pourrions améliorer…",
    "survey.error": "Impossible d'envoyer. Réessayez dans un instant.",
    "survey.send": "Envoyer",
    "survey.sending": "Envoi…",
    "survey.footer": "Merci de votre visite.",
    "tablepicker.discount.title": "Billets limités",
    "landing.promo.dates": "10-18 juillet",
    "landing.promo.headline": "Jusqu'à -45%",
    "landing.promo.sub": "Sur les billets",
    "pagar.notFound": "Nous n'avons pas trouvé cette réservation. Vérifiez le lien ou contactez l'établissement.",
    "pagar.confirmed.body": "Cette réservation est déjà confirmée. À bientôt !",
    "pagar.confirmed.btn": "Voir votre réservation",
    "pagar.unavailable": "Cette réservation n'est plus disponible. Si vous pensez qu'il s'agit d'une erreur, contactez l'établissement.",
    "pagar.intro": "Finalisez le paiement pour confirmer votre réservation. Votre table est réservée en attendant.",
    "pagar.label.session": "Séance",
    "pagar.label.artist": "Artiste",
    "pagar.label.table": "Table",
    "pagar.label.people": "Personnes",
    "pagar.label.menu": "Menu",
    "pagar.label.total": "Total",
    "pagar.error": "Impossible de démarrer le paiement. Réessayez ou contactez l'établissement.",
    "pagar.pay": "Payer {total}",
    "pagar.paying": "Redirection vers le paiement…",
    "pagar.secure": "Paiement sécurisé par carte via Redsys.",
    "modsesion.step.session": "Choisissez une séance",
    "modsesion.noSessions": "Il n'y a pas d'autres séances disponibles.",
    "modsesion.full": "Complet",
    "modsesion.currentSession": "C'est ta séance actuelle",
    "modmenu.heading": "Choisis ton menu",
    "modmenu.cheaperNote": "Non disponible",
    "modmenu.continue": "Continuer",
    "modmenu.diffNote": "Différence pour avoir choisi un menu plus cher que l'actuel.",
    "modsesion.step.table": "Choisissez votre table",
    "modsesion.step.review": "Vérifiez le changement",
    "modsesion.newSession": "Nouvelle séance",
    "modsesion.newTable": "Nouvelle table",
    "modsesion.toPay": "À régler",
    "modsesion.diffNote": "Différence pour avoir choisi une table plus chère que l'actuelle.",
    "modsesion.noCost": "Changement sans frais supplémentaires",
    "modsesion.pay": "Payer la différence",
    "modsesion.confirm": "Confirmer le changement",
    "modsesion.paySoon": "Le paiement de la différence sera bientôt disponible.",
    "modsesion.error": "Impossible de changer la séance. Veuillez réessayer.",
    "modsesion.done.title": "Réservation modifiée",
    "modsesion.done.body": "Votre réservation a été modifiée avec succès.",
    "modsesion.done.emailNote": "Nous t'avons envoyé un e-mail de confirmation avec ta nouvelle réservation.",
    "modsesion.summary.title": "Récapitulatif de ta nouvelle réservation",
    "modsesion.summary.people": "Personnes",
    "modsesion.summary.date": "Date",
    "modsesion.summary.time": "Heure",
    "modsesion.summary.table": "Table",
    "modsesion.summary.menu": "Menu",
    "modsesion.summary.newTotal": "Nouveau total",
    "common.loading": "Chargement…",
    "common.person_one": "{count} personne",
    "common.person_other": "{count} personnes",
    "manage.title": "Gérez votre réservation",
    "manage.btn.session": "Modifier la séance",
    "manage.btn.menu": "Voir/modifier le menu",
    "manage.btn.addGuests": "Ajouter des convives",
    "addguests.heading": "Combien de convives veux-tu ajouter ?",
    "addguests.current": "Ta réservation est actuellement pour {people}",
    "addguests.willAdd": "Tu ajoutes",
    "addguests.platos.heading": "Choisis les plats des nouveaux convives",
    "addguests.noFit": "Ta table actuelle ne peut pas accueillir {total} personnes.",
    "addguests.noFitAction": "Sélectionne une autre table disponible",
    "addguests.noTables": "Il n'y a pas de table disponible pour ce nombre de convives, nous sommes désolés.",
    "addguests.newTable": "Nouvelle table : {tier}",
    "addguests.mesa": "Table",
    "addguests.diffNote": "Entrée et menu des convives ajoutés.",
    "addguests.confirmPay": "Confirmer et payer",
    "addguests.original": "Réservation initiale",
    "addguests.modified": "Nouvelle réservation",
    "addguests.soon": "Nous configurerons les plats et le paiement des nouveaux convives à l'étape suivante.",
    "manage.btn.cancel": "Annuler la réservation",
    "manage.notFound": "Nous n'avons pas trouvé votre réservation. Vérifiez le lien dans votre e-mail.",
    "modify.soon.session": "Nous préparons cette option. Bientôt, vous pourrez changer votre séance ici.",
    "modify.soon.menu": "Nous préparons cette option. Bientôt, vous pourrez changer votre menu ici.",
    "modify.back": "← Retour",
    "cancelar.title": "Annuler la réservation",
    "cancelar.cancelled.label": "Réservation annulée",
    "cancelar.cancelled.refund": "Votre réservation a été annulée. Nous vous rembourserons {amount} sur votre moyen de paiement d'origine (cela peut prendre quelques jours ouvrés).",
    "cancelar.cancelled.noRefund": "Votre réservation a été annulée.",
    "cancelar.details": "Détails de votre réservation",
    "cancelar.label.persons": "Personnes",
    "cancelar.label.date": "Date",
    "cancelar.label.time": "Heure de la séance",
    "cancelar.label.ticket": "Entrée concert",
    "cancelar.label.menu": "Menu",
    "cancelar.label.artist": "Artiste",
    "cancelar.label.paid": "Payé",
    "cancelar.perPerson": "/ personne",
    "cancelar.totalRefund": "Total à rembourser",
    "cancelar.noRefund": "Sans remboursement",
    "cancelar.reason.full": "Entrée + menu",
    "cancelar.reason.menuOnly": "Seulement le menu · l'entrée n'est pas remboursable",
    "cancelar.noRefundNote": "Vous pouvez tout de même annuler pour libérer votre table, mais selon la politique d'annulation (moins de 24 h avant la séance) il n'y a pas de remboursement.",
    "cancelar.error.generic": "Impossible d'annuler la réservation. Veuillez réessayer plus tard.",
    "cancelar.confirm": "Confirmer l'annulation",
    "cancelar.confirming": "Annulation…",
    "cancelar.policy.title": "Politique d'annulation",
    "cancelar.cantCancel.title": "Cette réservation ne peut pas être annulée en ligne.",
    "cancelar.cantCancel.notPaid": "La réservation n'est pas marquée comme payée.",
    "cancelar.cantCancel.past": "La séance a déjà commencé ou est passée. Veuillez contacter le restaurant.",
    "cancelar.notFound": "Nous n'avons pas trouvé la réservation.",
    "landing.hero.price": "À partir de 5€ + Dîner",
    "landing.hero.subtitle": "Écoutez du Jazz en direct et dînez\ndans notre club du Manhattan\ndes années vingt.",
    "landing.hero.cta": "Découvrez la programmation",
    "landing.info.sessions": "SÉANCES",
    "landing.info.sessions.value": "19:00 - 21:00 - 23:00",
    "landing.info.duration": "DURÉE",
    "landing.info.duration.value": "1h 45 min",
    "landing.info.includes": "COMPREND",
    "landing.info.includes.value": "Concert + Menu",
    "landing.button.reserve": "Réservez Jazz Nights",
    "landing.programming.title": "Programmation",
    "landing.programming.artist.pending": "À confirmer",
    "landing.programming.photo.placeholder": "— photo —",
    "landing.howitworks.title": "Comment ça marche",
    "landing.howitworks.step1.title": "CHOISISSEZ LA SÉANCE",
    "landing.howitworks.step1.description": "Sélectionnez l'horaire que vous préférez parmi nos trois séances.",
    "landing.howitworks.step2.title": "CHOISISSEZ L'EMPLACEMENT",
    "landing.howitworks.step2.description": "Choisissez votre zone préférée pour vivre votre expérience.",
    "landing.howitworks.step3.title": "SÉLECTIONNEZ VOTRE MENU",
    "landing.howitworks.step3.description": "Découvrez la proposition gastronomique que nous avons créée.",
    "landing.howitworks.step4.title": "PROFITEZ DE LA SOIRÉE",
    "landing.howitworks.step4.description": "Laissez-vous emporter par le jazz, la gastronomie et la magie des années vingt.",
    "sesiones.personas.heading": "Combien de personnes êtes-vous ?",
    "sesiones.personas.btn_remove_aria": "Retirer une personne",
    "sesiones.personas.btn_add_aria": "Ajouter une personne",
    "sesiones.personas.btn_continue": "Continuer",
    "sesiones.fecha.heading": "Choisissez la date",
    "sesiones.fecha.loading": "Chargement de la programmation…",
    "sesiones.fecha.empty_state": "Aucune séance n'est encore programmée. Revenez bientôt.",
    "sesiones.fecha.event_title": "Jazz Night à Manhattan",
    "sesiones.fecha.event_description": "Écoutez du Jazz en direct et dînez dans notre club du Manhattan des années vingt.",
    "sesiones.fecha.event_price": "Entrée à partir de 5€ + dîner",
    "sesiones.fecha.btn_back": "‹ Retour",
    "sesiones.fecha.btn_continue": "Continuer",
    "sesiones.hora.heading": "Sélectionnez l'horaire de la séance",
    "sesiones.hora.subtitle": "Sélectionnez l'horaire que vous préférez parmi nos trois séances.",
    "sesiones.hora.session_type": "Concert + dîner",
    "sesiones.hora.event_price": "Entrée à partir de 5€ + dîner",
    "sesiones.hora.btn_back": "‹ Retour",
    "sesiones.hora.btn_continue": "Continuer",
    "ubicacion.breadcrumb.personas": "{n} personnes",
    "ubicacion.heading.title": "Choisissez votre emplacement",
    "ubicacion.heading.subtitle": "Le prix de l'entrée dépend de la zone sélectionnée. Les tables grises ne sont pas disponibles.",
    "ubicacion.loading.message": "Chargement du plan…",
    "ubicacion.back.button": "‹ Retour",
    "ubicacion.cta.loading": "Réservation…",
    "ubicacion.cta.ready": "Continuer",
    "ubicacion.modal.title": "Avant de continuer",
    "ubicacion.modal.description": "Vous avez choisi une table sur le patio ; ces tables se trouvent derrière la scène, la visibilité du concert peut donc être limitée ou nulle.",
    "ubicacion.modal.confirm_button": "Oui, continuer",
    "ubicacion.modal.confirm_loading": "Réservation…",
    "ubicacion.modal.cancel_button": "Je veux en choisir une autre",
    "menu.step_heading": "Sélectionnez votre menu",
    "menu.step_subtitle": "L'expérience Jazz Nights comprend l'entrée et le menu du dîner pour tous les participants.",
    "menu.error_invalid": "Sélectionnez un menu valide",
    "menu.loading": "Chargement…",
    "menu.price_per_person": "€ / personne",
    "menu.course_mandatory": "Obligatoire",
    "menu.course_shared": "À partager",
    "menu.course_drink_variant": "Boisson + cocktail",
    "menu.course_label_entrantes": "Entrées",
    "menu.course_label_principal": "Plat principal",
    "menu.course_label_postres": "Desserts",
    "menu.course_label_bebida": "Boisson",
    "menu.course_instruction_principal": "Choisissez 1 plat principal par personne",
    "menu.course_instruction_postre": "Choisissez 1 dessert par personne",
    "menu.button_remove": "Retirer {name}",
    "menu.button_add": "Ajouter {name}",
    "menu.button_selected": "Menu sélectionné",
    "menu.button_choose": "Choisissez le {name}",
    "menu.button_back": "‹ Retour",
    "menu.button_continue": "Continuer vers le paiement",
    "menu.error_incomplete_courses": "Choisissez {seats} {course} au total (vous en avez {current})",
    "menu.error_save_failed": "Impossible d'enregistrer le menu",
    "menu.breadcrumb_party_size": "{n} personnes",
    "pago.loading.label": "Chargement de la réservation…",
    "pago.revisar.heading": "VÉRIFIEZ QUE TOUT EST CORRECT",
    "pago.revisar.summary.personas": "Personnes",
    "pago.revisar.summary.fecha": "Date",
    "pago.revisar.summary.hora_sesion": "Horaire de la séance",
    "pago.revisar.summary.entrada_concierto": "Entrée du concert",
    "pago.revisar.summary.entrada_valor": "{price} / personne",
    "pago.revisar.summary.menu": "Menu",
    "pago.revisar.summary.menu_valor": "{name} · {price} / personne",
    "pago.revisar.summary.principales": "Plats principaux",
    "pago.revisar.summary.postres": "Desserts",
    "pago.revisar.recomendacion": "Nous vous recommandons d'arriver entre 15 et 30 minutes avant le début de l'expérience",
    "pago.revisar.cta": "Confirmez les informations",
    "pago.confirmed.heading": "RÉSERVATION CONFIRMÉE !",
    "pago.confirmed.demo_note": "Mode démo — le paiement réel est activé en production.",
    "pago.contacto.heading": "POUR FINIR, NOUS AVONS BESOIN DE VOS COORDONNÉES",
    "pago.contacto.seccion_datos.titulo": "Coordonnées de contact",
    "pago.contacto.form.nombre_placeholder": "Nom et prénom*",
    "pago.contacto.form.email_placeholder": "E-mail*",
    "pago.contacto.form.telefono_placeholder": "Téléphone*",
    "pago.contacto.form.comentarios_placeholder": "Commentaires ou allergies",
    "pago.contacto.seccion_condiciones.titulo": "Conditions",
    "pago.contacto.condiciones.experiencia": "J'ai lu que l'expérience comprend l'entrée et le dîner",
    "pago.contacto.condiciones.politicas": "J'accepte le Traitement des Données, la Politique de Confidentialité et la Politique d'Annulation",
    "pago.contacto.condiciones.politicas_parte1": "J'accepte le ",
    "pago.contacto.condiciones.politicas_parte2": "Traitement des Données",
    "pago.contacto.condiciones.politicas_parte3": ", ",
    "pago.contacto.condiciones.politicas_parte4": "la Politique de Confidentialité",
    "pago.contacto.condiciones.politicas_parte5": " et ",
    "pago.contacto.condiciones.politicas_parte6": "la Politique d'Annulation",
    "pago.contacto.condiciones.comunicaciones": "Je consens à recevoir des communications du restaurant par e-mail et/ou SMS à des fins commerciales.",
    "pago.contacto.recomendacion": "Nous vous recommandons d'arriver entre 15 et 30 minutes avant le début de l'expérience",
    "pago.contacto.seccion_total.titulo": "Total de la réservation",
    "pago.contacto.total.entrada": "Entrée",
    "pago.contacto.total.entrada_subtexto": "{price} × {n}",
    "pago.contacto.total.menu": "Menu",
    "pago.contacto.total.menu_subtexto": "{price} × {n}",
    "pago.contacto.total.total": "Total",
    "pago.contacto.error_completos": "Renseignez le nom, l'e-mail et le téléphone pour continuer.",
    "pago.contacto.error_condiciones": "Vous devez accepter les conditions pour continuer.",
    "pago.contacto.error_pago": "Erreur lors de l'initiation du paiement",
    "pago.contacto.volver": "‹ Retour",
    "pago.contacto.cta": "Continuer vers le paiement",
    "pago.checkout.procesando": "Traitement en cours…",
    "pago.checkout.cta": "Payer",
    "pago.checkout.error_generico": "Erreur lors du paiement",
    "politicaCancelacion.titulo": "Politique d'annulation",
    "politicaCancelacion.contenido.encabezado": "Annulations et modifications",
    "politicaCancelacion.contenido.regla1": "Plus de 48h avant la séance : annulation gratuite et remboursement intégral (entrée + menu).",
    "politicaCancelacion.contenido.regla2": "Entre 48h et 24h avant : le menu est remboursé ; l'entrée du concert n'est pas remboursable.",
    "politicaCancelacion.contenido.regla3": "Moins de 24h avant ou non-présentation : aucun remboursement.",
    "politicaCancelacion.contenido.cambiosFecha": "Changements de date sans frais jusqu'à 48h avant la séance, sous réserve de disponibilité.",
    "politicaCancelacion.boton.volver": "‹ Retour",
    "confirmacion.error.notFound": "Réservation introuvable.",
    "confirmacion.loading": "Chargement de la confirmation…",
    "confirmacion.processing.label": "Traitement du paiement",
    "confirmacion.processing.title": "Nous confirmons votre réservation",
    "confirmacion.processing.message": "Cela prend généralement quelques secondes. Ne fermez pas cette page.",
    "confirmacion.failed.label": "Paiement non abouti",
    "confirmacion.failed.title": "Nous n'avons pas pu confirmer votre réservation",
    "confirmacion.failed.message": "Si vous pensez qu'il s'agit d'une erreur, contactez le restaurant avec votre référence : {referenceId}",
    "confirmacion.success.label": "Réservation confirmée",
    "confirmacion.success.title": "Nous vous attendons samedi",
    "confirmacion.details.label": "Détails",
    "confirmacion.details.artist": "Artiste",
    "confirmacion.details.people": "Personnes",
    "confirmacion.details.totalPaid": "Total payé",
    "confirmacion.details.reference": "Référence",
    "confirmacion.dishes.label": "Plats choisis",
    "confirmacion.dishes.principal": "Plat principal",
    "confirmacion.dishes.postre": "Dessert",
    "confirmacion.ticket.label": "Votre entrée",
    "confirmacion.ticket.qrAlt": "QR de votre réservation",
    "confirmacion.ticket.instructions": "Présentez ce QR à l'entrée le jour du spectacle.",
    "confirmacion.email.sent": "Nous vous avons envoyé les détails à {email}.",
    "layout.header.logo.aria_label": "Voltereta — accueil",
    "layout.footer.logo.aria_label": "Voltereta — accueil",
    "wizard.header.title": "Réservez votre Jazz Night",
    "tablepicker.zone.salon": "Salle principale",
    "tablepicker.zone.patio": "Patio",
    "tablepicker.table.tooltip": "Table {number} · {capacity} pers. · {price} entrée",
    "tablepicker.backdrop.escenario": "SCÈNE",
    "tablepicker.backdrop.tras_escenario": "DERRIÈRE LA SCÈNE",
    "stepper.progress_label": "Progression de la réservation",
    "ubicacion.error.loading_tables": "Erreur de chargement des tables",
    "ubicacion.error.reserve_failed": "Impossible de réserver la table",
    "ubicacion.breadcrumb.table_prefix": "table"
  },
  "nl": {
    "pagar.title": "Je reservering",
    "survey.title": "Jouw mening",
    "survey.notFound": "Deze enquête is niet beschikbaar. Als je denkt dat dit een fout is, neem contact op met de zaak.",
    "survey.intro": "Hoe was onze Jazz Night?",
    "survey.thanks": "Bedankt! Jouw mening helpt ons om elke avond beter te maken.",
    "survey.q.global": "De volledige ervaring",
    "survey.q.music": "De muziek",
    "survey.q.food": "Het eten",
    "survey.q.service": "De bediening",
    "survey.q.recommend": "Zou je ons aanbevelen?",
    "survey.q.frequency": "Hoe vaak bezoek je ons?",
    "survey.q.comment": "Nog iets wat je ons wilt vertellen? (optioneel)",
    "survey.freq.first_time": "Mijn eerste keer",
    "survey.freq.sometimes": "Zo nu en dan",
    "survey.freq.monthly": "Eén keer per maand",
    "survey.freq.weekly": "Eén keer per week",
    "survey.comment.placeholder": "Wat je leuk vond, wat we kunnen verbeteren…",
    "survey.error": "Verzenden mislukt. Probeer het zo opnieuw.",
    "survey.send": "Versturen",
    "survey.sending": "Versturen…",
    "survey.footer": "Bedankt voor je bezoek.",
    "tablepicker.discount.title": "Beperkte kaarten",
    "landing.promo.dates": "10-18 juli",
    "landing.promo.headline": "Tot -45%",
    "landing.promo.sub": "Op kaarten",
    "pagar.notFound": "We konden deze reservering niet vinden. Controleer de link of neem contact op met de zaak.",
    "pagar.confirmed.body": "Deze reservering is al bevestigd. Tot snel!",
    "pagar.confirmed.btn": "Bekijk je reservering",
    "pagar.unavailable": "Deze reservering is niet meer beschikbaar. Als je denkt dat dit een fout is, neem dan contact op met de zaak.",
    "pagar.intro": "Rond de betaling af om je reservering te bevestigen. Je tafel blijft ondertussen gereserveerd.",
    "pagar.label.session": "Sessie",
    "pagar.label.artist": "Artiest",
    "pagar.label.table": "Tafel",
    "pagar.label.people": "Personen",
    "pagar.label.menu": "Menu",
    "pagar.label.total": "Totaal",
    "pagar.error": "We konden de betaling niet starten. Probeer het opnieuw of neem contact op met de zaak.",
    "pagar.pay": "{total} betalen",
    "pagar.paying": "Doorsturen naar betaling…",
    "pagar.secure": "Veilige kaartbetaling via Redsys.",
    "modsesion.step.session": "Kies een sessie",
    "modsesion.noSessions": "Er zijn geen andere sessies beschikbaar.",
    "modsesion.full": "Vol",
    "modsesion.currentSession": "Dit is je huidige sessie",
    "modmenu.heading": "Kies je menu",
    "modmenu.cheaperNote": "Niet beschikbaar",
    "modmenu.continue": "Doorgaan",
    "modmenu.diffNote": "Verschil omdat je een duurder menu dan het huidige hebt gekozen.",
    "modsesion.step.table": "Kies je tafel",
    "modsesion.step.review": "Controleer de wijziging",
    "modsesion.newSession": "Nieuwe sessie",
    "modsesion.newTable": "Nieuwe tafel",
    "modsesion.toPay": "Te betalen",
    "modsesion.diffNote": "Verschil omdat je een duurdere tafel dan de huidige hebt gekozen.",
    "modsesion.noCost": "Wijziging zonder extra kosten",
    "modsesion.pay": "Verschil betalen",
    "modsesion.confirm": "Wijziging bevestigen",
    "modsesion.paySoon": "Het betalen van het verschil is binnenkort beschikbaar.",
    "modsesion.error": "We konden de sessie niet wijzigen. Probeer het opnieuw.",
    "modsesion.done.title": "Reservering gewijzigd",
    "modsesion.done.body": "Je reservering is succesvol gewijzigd.",
    "modsesion.done.emailNote": "We hebben je een bevestigingsmail met je nieuwe reservering gestuurd.",
    "modsesion.summary.title": "Overzicht van je nieuwe reservering",
    "modsesion.summary.people": "Personen",
    "modsesion.summary.date": "Datum",
    "modsesion.summary.time": "Tijd",
    "modsesion.summary.table": "Tafel",
    "modsesion.summary.menu": "Menu",
    "modsesion.summary.newTotal": "Nieuw totaal",
    "common.loading": "Laden…",
    "common.person_one": "{count} persoon",
    "common.person_other": "{count} personen",
    "manage.title": "Beheer je reservering",
    "manage.btn.session": "Sessie wijzigen",
    "manage.btn.menu": "Menu bekijken/wijzigen",
    "manage.btn.addGuests": "Gasten toevoegen",
    "addguests.heading": "Hoeveel gasten wil je toevoegen?",
    "addguests.current": "Je reservering is momenteel voor {people}",
    "addguests.willAdd": "Je voegt toe",
    "addguests.platos.heading": "Kies de gerechten voor de nieuwe gasten",
    "addguests.noFit": "Aan je huidige tafel passen geen {total} personen.",
    "addguests.noFitAction": "Selecteer een andere beschikbare tafel",
    "addguests.noTables": "Er zijn geen tafels beschikbaar voor dat aantal gasten, het spijt ons.",
    "addguests.newTable": "Nieuwe tafel: {tier}",
    "addguests.mesa": "Tafel",
    "addguests.diffNote": "Toegang en menu voor de toegevoegde gasten.",
    "addguests.confirmPay": "Bevestigen en betalen",
    "addguests.original": "Oorspronkelijke reservering",
    "addguests.modified": "Nieuwe reservering",
    "addguests.soon": "In de volgende stap regelen we de gerechten en de betaling voor de nieuwe gasten.",
    "manage.btn.cancel": "Reservering annuleren",
    "manage.notFound": "We konden je reservering niet vinden. Controleer de link in je e-mail.",
    "modify.soon.session": "We werken aan deze optie. Binnenkort kun je hier je sessie wijzigen.",
    "modify.soon.menu": "We werken aan deze optie. Binnenkort kun je hier je menu wijzigen.",
    "modify.back": "← Terug",
    "cancelar.title": "Reservering annuleren",
    "cancelar.cancelled.label": "Reservering geannuleerd",
    "cancelar.cancelled.refund": "Je reservering is geannuleerd. We betalen {amount} terug op je oorspronkelijke betaalmethode (dit kan enkele werkdagen duren).",
    "cancelar.cancelled.noRefund": "Je reservering is geannuleerd.",
    "cancelar.details": "Details van je reservering",
    "cancelar.label.persons": "Personen",
    "cancelar.label.date": "Datum",
    "cancelar.label.time": "Tijd van de sessie",
    "cancelar.label.ticket": "Concertticket",
    "cancelar.label.menu": "Menu",
    "cancelar.label.artist": "Artiest",
    "cancelar.label.paid": "Betaald",
    "cancelar.perPerson": "/ persoon",
    "cancelar.totalRefund": "Totaal terug te betalen",
    "cancelar.noRefund": "Geen terugbetaling",
    "cancelar.reason.full": "Ticket + menu",
    "cancelar.reason.menuOnly": "Alleen het menu · het ticket is niet terugbetaalbaar",
    "cancelar.noRefundNote": "Je kunt nog steeds annuleren om je tafel vrij te maken, maar volgens het annuleringsbeleid (minder dan 24 u voor de sessie) is er geen terugbetaling.",
    "cancelar.error.generic": "We konden de reservering niet annuleren. Probeer het later opnieuw.",
    "cancelar.confirm": "Annulering bevestigen",
    "cancelar.confirming": "Annuleren…",
    "cancelar.policy.title": "Annuleringsbeleid",
    "cancelar.cantCancel.title": "Deze reservering kan niet online worden geannuleerd.",
    "cancelar.cantCancel.notPaid": "De reservering staat niet als betaald geregistreerd.",
    "cancelar.cantCancel.past": "De sessie is al begonnen of voorbij. Neem contact op met het restaurant.",
    "cancelar.notFound": "We konden de reservering niet vinden.",
    "landing.hero.price": "Vanaf 5€ + diner",
    "landing.hero.subtitle": "Luister naar live jazz en dineer\nin onze club in het Manhattan\nvan de jaren twintig.",
    "landing.hero.cta": "Ontdek het programma",
    "landing.info.sessions": "SESSIES",
    "landing.info.sessions.value": "19:00 - 21:00 - 23:00",
    "landing.info.duration": "DUUR",
    "landing.info.duration.value": "1u 45 min",
    "landing.info.includes": "INBEGREPEN",
    "landing.info.includes.value": "Concert + Menu",
    "landing.button.reserve": "Reserveer Jazz Nights",
    "landing.programming.title": "Programma",
    "landing.programming.artist.pending": "Nog te bevestigen",
    "landing.programming.photo.placeholder": "— foto —",
    "landing.howitworks.title": "Hoe het werkt",
    "landing.howitworks.step1.title": "KIES EEN SESSIE",
    "landing.howitworks.step1.description": "Selecteer het tijdstip van jouw voorkeur uit onze drie sessies.",
    "landing.howitworks.step2.title": "KIES EEN PLEK",
    "landing.howitworks.step2.description": "Kies jouw favoriete zone om de ervaring te beleven.",
    "landing.howitworks.step3.title": "SELECTEER JE MENU",
    "landing.howitworks.step3.description": "Ontdek het gastronomische voorstel dat we hebben samengesteld.",
    "landing.howitworks.step4.title": "GENIET VAN DE AVOND",
    "landing.howitworks.step4.description": "Laat je meevoeren door de jazz, de gastronomie en de magie van de jaren twintig.",
    "sesiones.personas.heading": "Met hoeveel personen zijn jullie?",
    "sesiones.personas.btn_remove_aria": "Een persoon verwijderen",
    "sesiones.personas.btn_add_aria": "Een persoon toevoegen",
    "sesiones.personas.btn_continue": "Verder",
    "sesiones.fecha.heading": "Kies de datum",
    "sesiones.fecha.loading": "Programma laden…",
    "sesiones.fecha.empty_state": "Er zijn nog geen sessies gepland. Kom snel terug.",
    "sesiones.fecha.event_title": "Jazz Night in Manhattan",
    "sesiones.fecha.event_description": "Luister naar live jazz en dineer in onze club in het Manhattan van de jaren twintig.",
    "sesiones.fecha.event_price": "Entree vanaf 5€ + diner",
    "sesiones.fecha.btn_back": "‹ Terug",
    "sesiones.fecha.btn_continue": "Verder",
    "sesiones.hora.heading": "Selecteer het tijdstip van de sessie",
    "sesiones.hora.subtitle": "Selecteer het tijdstip van jouw voorkeur uit onze drie sessies.",
    "sesiones.hora.session_type": "Concert + diner",
    "sesiones.hora.event_price": "Entree vanaf 5€ + diner",
    "sesiones.hora.btn_back": "‹ Terug",
    "sesiones.hora.btn_continue": "Verder",
    "ubicacion.breadcrumb.personas": "{n} personen",
    "ubicacion.heading.title": "Kies je plek",
    "ubicacion.heading.subtitle": "De prijs van de entree hangt af van de gekozen zone. De grijze tafels zijn niet beschikbaar.",
    "ubicacion.loading.message": "Plattegrond laden…",
    "ubicacion.back.button": "‹ Terug",
    "ubicacion.cta.loading": "Reserveren…",
    "ubicacion.cta.ready": "Verder",
    "ubicacion.modal.title": "Voordat je verdergaat",
    "ubicacion.modal.description": "Je hebt een tafel op het terras gekozen. Deze tafels bevinden zich achter het podium, waardoor het zicht op het concert beperkt of nihil kan zijn.",
    "ubicacion.modal.confirm_button": "Ja, ga verder",
    "ubicacion.modal.confirm_loading": "Reserveren…",
    "ubicacion.modal.cancel_button": "Ik wil een andere kiezen",
    "menu.step_heading": "Selecteer je menu",
    "menu.step_subtitle": "De Jazz Nights-ervaring omvat entree en dinermenu voor alle gasten.",
    "menu.error_invalid": "Selecteer een geldig menu",
    "menu.loading": "Laden…",
    "menu.price_per_person": "€ / persoon",
    "menu.course_mandatory": "Verplicht",
    "menu.course_shared": "Om te delen",
    "menu.course_drink_variant": "Drankje + cocktail",
    "menu.course_label_entrantes": "Voorgerechten",
    "menu.course_label_principal": "Hoofdgerecht",
    "menu.course_label_postres": "Desserts",
    "menu.course_label_bebida": "Drankje",
    "menu.course_instruction_principal": "Kies 1 hoofdgerecht per persoon",
    "menu.course_instruction_postre": "Kies 1 dessert per persoon",
    "menu.button_remove": "{name} verwijderen",
    "menu.button_add": "{name} toevoegen",
    "menu.button_selected": "Menu geselecteerd",
    "menu.button_choose": "Kies het {name}",
    "menu.button_back": "‹ Terug",
    "menu.button_continue": "Verder naar betaling",
    "menu.error_incomplete_courses": "Kies in totaal {seats} {course} (je hebt er {current})",
    "menu.error_save_failed": "Het menu kon niet worden opgeslagen",
    "menu.breadcrumb_party_size": "{n} personen",
    "pago.loading.label": "Reservering laden…",
    "pago.revisar.heading": "CONTROLEER OF ALLES KLOPT",
    "pago.revisar.summary.personas": "Personen",
    "pago.revisar.summary.fecha": "Datum",
    "pago.revisar.summary.hora_sesion": "Tijd sessie",
    "pago.revisar.summary.entrada_concierto": "Entree concert",
    "pago.revisar.summary.entrada_valor": "{price} / persoon",
    "pago.revisar.summary.menu": "Menu",
    "pago.revisar.summary.menu_valor": "{name} · {price} / persoon",
    "pago.revisar.summary.principales": "Hoofdgerechten",
    "pago.revisar.summary.postres": "Desserts",
    "pago.revisar.recomendacion": "We raden je aan 15 tot 30 minuten voor aanvang van de ervaring aanwezig te zijn",
    "pago.revisar.cta": "Bevestig de gegevens",
    "pago.confirmed.heading": "RESERVERING BEVESTIGD!",
    "pago.confirmed.demo_note": "Demomodus — de echte betaling wordt geactiveerd in productie.",
    "pago.contacto.heading": "TOT SLOT HEBBEN WE JE CONTACTGEGEVENS NODIG",
    "pago.contacto.seccion_datos.titulo": "Contactgegevens",
    "pago.contacto.form.nombre_placeholder": "Voor- en achternaam*",
    "pago.contacto.form.email_placeholder": "E-mail*",
    "pago.contacto.form.telefono_placeholder": "Telefoon*",
    "pago.contacto.form.comentarios_placeholder": "Opmerkingen of allergieën",
    "pago.contacto.seccion_condiciones.titulo": "Voorwaarden",
    "pago.contacto.condiciones.experiencia": "Ik heb gelezen dat de ervaring entree en diner omvat",
    "pago.contacto.condiciones.politicas": "Ik ga akkoord met de Gegevensverwerking, het Privacybeleid en het Annuleringsbeleid",
    "pago.contacto.condiciones.politicas_parte1": "Ik ga akkoord met de ",
    "pago.contacto.condiciones.politicas_parte2": "Gegevensverwerking",
    "pago.contacto.condiciones.politicas_parte3": ", ",
    "pago.contacto.condiciones.politicas_parte4": "het Privacybeleid",
    "pago.contacto.condiciones.politicas_parte5": " en ",
    "pago.contacto.condiciones.politicas_parte6": "het Annuleringsbeleid",
    "pago.contacto.condiciones.comunicaciones": "Ik geef toestemming voor het ontvangen van commerciële berichten van het restaurant per e-mail en/of sms.",
    "pago.contacto.recomendacion": "We raden je aan 15 tot 30 minuten voor aanvang van de ervaring aanwezig te zijn",
    "pago.contacto.seccion_total.titulo": "Totaal van de reservering",
    "pago.contacto.total.entrada": "Entree",
    "pago.contacto.total.entrada_subtexto": "{price} × {n}",
    "pago.contacto.total.menu": "Menu",
    "pago.contacto.total.menu_subtexto": "{price} × {n}",
    "pago.contacto.total.total": "Totaal",
    "pago.contacto.error_completos": "Vul naam, e-mail en telefoon in om verder te gaan.",
    "pago.contacto.error_condiciones": "Je moet de voorwaarden accepteren om verder te gaan.",
    "pago.contacto.error_pago": "Fout bij het starten van de betaling",
    "pago.contacto.volver": "‹ Terug",
    "pago.contacto.cta": "Verder naar betaling",
    "pago.checkout.procesando": "Verwerken…",
    "pago.checkout.cta": "Betalen",
    "pago.checkout.error_generico": "Fout bij de betaling",
    "politicaCancelacion.titulo": "Annuleringsbeleid",
    "politicaCancelacion.contenido.encabezado": "Annuleringen en wijzigingen",
    "politicaCancelacion.contenido.regla1": "Meer dan 48u voor de sessie: gratis annulering en volledige terugbetaling (entree + menu).",
    "politicaCancelacion.contenido.regla2": "Tussen 48u en 24u ervoor: het menu wordt terugbetaald; de entree voor het concert is niet terugbetaalbaar.",
    "politicaCancelacion.contenido.regla3": "Minder dan 24u ervoor of bij niet verschijnen: geen terugbetaling.",
    "politicaCancelacion.contenido.cambiosFecha": "Datumwijzigingen gratis tot 48u voor de sessie, afhankelijk van beschikbaarheid.",
    "politicaCancelacion.boton.volver": "‹ Terug",
    "confirmacion.error.notFound": "Reservering niet gevonden.",
    "confirmacion.loading": "Bevestiging laden…",
    "confirmacion.processing.label": "Betaling verwerken",
    "confirmacion.processing.title": "We bevestigen je reservering",
    "confirmacion.processing.message": "Dit duurt meestal een paar seconden. Sluit deze pagina niet.",
    "confirmacion.failed.label": "Betaling niet voltooid",
    "confirmacion.failed.title": "We konden je reservering niet bevestigen",
    "confirmacion.failed.message": "Als je denkt dat dit een fout is, neem dan contact op met het restaurant met je referentie: {referenceId}",
    "confirmacion.success.label": "Reservering bevestigd",
    "confirmacion.success.title": "We verwachten je zaterdag",
    "confirmacion.details.label": "Details",
    "confirmacion.details.artist": "Artiest",
    "confirmacion.details.people": "Personen",
    "confirmacion.details.totalPaid": "Totaal betaald",
    "confirmacion.details.reference": "Referentie",
    "confirmacion.dishes.label": "Gekozen gerechten",
    "confirmacion.dishes.principal": "Hoofdgerecht",
    "confirmacion.dishes.postre": "Dessert",
    "confirmacion.ticket.label": "Je entreebewijs",
    "confirmacion.ticket.qrAlt": "QR van je reservering",
    "confirmacion.ticket.instructions": "Toon deze QR bij de ingang op de dag van de voorstelling.",
    "confirmacion.email.sent": "We hebben de details naar {email} gestuurd.",
    "layout.header.logo.aria_label": "Voltereta — home",
    "layout.footer.logo.aria_label": "Voltereta — home",
    "wizard.header.title": "Reserveer je Jazz Night",
    "tablepicker.zone.salon": "Hoofdzaal",
    "tablepicker.zone.patio": "Terras",
    "tablepicker.table.tooltip": "Tafel {number} · {capacity} pers. · {price} entree",
    "tablepicker.backdrop.escenario": "PODIUM",
    "tablepicker.backdrop.tras_escenario": "ACHTER HET PODIUM",
    "stepper.progress_label": "Voortgang van de reservering",
    "ubicacion.error.loading_tables": "Fout bij het laden van tafels",
    "ubicacion.error.reserve_failed": "De tafel kon niet worden gereserveerd",
    "ubicacion.breadcrumb.table_prefix": "tafel"
  },
  "it": {
    "pagar.title": "La tua prenotazione",
    "survey.title": "La tua opinione",
    "survey.notFound": "Questo sondaggio non è disponibile. Se pensi che sia un errore, contatta il locale.",
    "survey.intro": "Com'è stata la nostra Jazz Night?",
    "survey.thanks": "Grazie! La tua opinione ci aiuta a rendere ogni serata migliore.",
    "survey.q.global": "L'esperienza completa",
    "survey.q.music": "La musica",
    "survey.q.food": "Il cibo",
    "survey.q.service": "Il servizio",
    "survey.q.recommend": "Ci consiglieresti?",
    "survey.q.frequency": "Con che frequenza ci visiti?",
    "survey.q.comment": "Qualcos'altro che vuoi dirci? (facoltativo)",
    "survey.freq.first_time": "È la mia prima volta",
    "survey.freq.sometimes": "Ogni tanto",
    "survey.freq.monthly": "Una volta al mese",
    "survey.freq.weekly": "Una volta a settimana",
    "survey.comment.placeholder": "Ciò che ti è piaciuto, ciò che possiamo migliorare…",
    "survey.error": "Impossibile inviare. Riprova tra un momento.",
    "survey.send": "Invia",
    "survey.sending": "Invio…",
    "survey.footer": "Grazie per essere stati con noi.",
    "tablepicker.discount.title": "Biglietti limitati",
    "landing.promo.dates": "10-18 luglio",
    "landing.promo.headline": "Fino al -45%",
    "landing.promo.sub": "Sui biglietti",
    "pagar.notFound": "Non abbiamo trovato questa prenotazione. Controlla il link o contatta il locale.",
    "pagar.confirmed.body": "Questa prenotazione è già confermata. A presto!",
    "pagar.confirmed.btn": "Vedi la tua prenotazione",
    "pagar.unavailable": "Questa prenotazione non è più disponibile. Se pensi che sia un errore, contatta il locale.",
    "pagar.intro": "Completa il pagamento per confermare la prenotazione. Il tuo tavolo resta riservato nel frattempo.",
    "pagar.label.session": "Sessione",
    "pagar.label.artist": "Artista",
    "pagar.label.table": "Tavolo",
    "pagar.label.people": "Persone",
    "pagar.label.menu": "Menù",
    "pagar.label.total": "Totale",
    "pagar.error": "Non è stato possibile avviare il pagamento. Riprova o contatta il locale.",
    "pagar.pay": "Paga {total}",
    "pagar.paying": "Reindirizzamento al pagamento…",
    "pagar.secure": "Pagamento sicuro con carta tramite Redsys.",
    "modsesion.step.session": "Scegli una sessione",
    "modsesion.noSessions": "Non ci sono altre sessioni disponibili.",
    "modsesion.full": "Completo",
    "modsesion.currentSession": "Questa è la tua sessione attuale",
    "modmenu.heading": "Scegli il tuo menu",
    "modmenu.cheaperNote": "Non disponibile",
    "modmenu.continue": "Continua",
    "modmenu.diffNote": "Differenza per aver scelto un menu più caro di quello attuale.",
    "modsesion.step.table": "Scegli il tuo tavolo",
    "modsesion.step.review": "Controlla la modifica",
    "modsesion.newSession": "Nuova sessione",
    "modsesion.newTable": "Nuovo tavolo",
    "modsesion.toPay": "Da pagare",
    "modsesion.diffNote": "Differenza per aver scelto un tavolo più caro di quello attuale.",
    "modsesion.noCost": "Modifica senza costi aggiuntivi",
    "modsesion.pay": "Paga la differenza",
    "modsesion.confirm": "Conferma modifica",
    "modsesion.paySoon": "Il pagamento della differenza sarà presto disponibile.",
    "modsesion.error": "Impossibile cambiare la sessione. Riprova.",
    "modsesion.done.title": "Prenotazione modificata",
    "modsesion.done.body": "La tua prenotazione è stata modificata con successo.",
    "modsesion.done.emailNote": "Ti abbiamo inviato un'email di conferma con la tua nuova prenotazione.",
    "modsesion.summary.title": "Riepilogo della tua nuova prenotazione",
    "modsesion.summary.people": "Persone",
    "modsesion.summary.date": "Data",
    "modsesion.summary.time": "Ora",
    "modsesion.summary.table": "Tavolo",
    "modsesion.summary.menu": "Menu",
    "modsesion.summary.newTotal": "Nuovo totale",
    "common.loading": "Caricamento…",
    "common.person_one": "{count} persona",
    "common.person_other": "{count} persone",
    "manage.title": "Gestisci la tua prenotazione",
    "manage.btn.session": "Modifica sessione",
    "manage.btn.menu": "Vedi/modifica menù",
    "manage.btn.addGuests": "Aggiungi ospiti",
    "addguests.heading": "Quanti ospiti vuoi aggiungere?",
    "addguests.current": "La tua prenotazione è attualmente per {people}",
    "addguests.willAdd": "Stai aggiungendo",
    "addguests.platos.heading": "Scegli i piatti dei nuovi ospiti",
    "addguests.noFit": "Al tuo tavolo attuale non entrano {total} persone.",
    "addguests.noFitAction": "Seleziona un altro tavolo disponibile",
    "addguests.noTables": "Non ci sono tavoli disponibili per quel numero di ospiti, ci dispiace.",
    "addguests.newTable": "Nuovo tavolo: {tier}",
    "addguests.mesa": "Tavolo",
    "addguests.diffNote": "Ingresso e menù degli ospiti aggiunti.",
    "addguests.confirmPay": "Conferma e paga",
    "addguests.original": "Prenotazione originale",
    "addguests.modified": "Nuova prenotazione",
    "addguests.soon": "Configureremo i piatti e il pagamento dei nuovi ospiti nel passaggio successivo.",
    "manage.btn.cancel": "Annulla prenotazione",
    "manage.notFound": "Non abbiamo trovato la tua prenotazione. Controlla il link nella tua e-mail.",
    "modify.soon.session": "Stiamo preparando questa opzione. Presto potrai cambiare la tua sessione da qui.",
    "modify.soon.menu": "Stiamo preparando questa opzione. Presto potrai cambiare il tuo menù da qui.",
    "modify.back": "← Indietro",
    "cancelar.title": "Annulla prenotazione",
    "cancelar.cancelled.label": "Prenotazione annullata",
    "cancelar.cancelled.refund": "La tua prenotazione è stata annullata. Ti rimborseremo {amount} sul metodo di pagamento originale (potrebbero volerci alcuni giorni lavorativi).",
    "cancelar.cancelled.noRefund": "La tua prenotazione è stata annullata.",
    "cancelar.details": "Dettagli della tua prenotazione",
    "cancelar.label.persons": "Persone",
    "cancelar.label.date": "Data",
    "cancelar.label.time": "Orario della sessione",
    "cancelar.label.ticket": "Ingresso concerto",
    "cancelar.label.menu": "Menù",
    "cancelar.label.artist": "Artista",
    "cancelar.label.paid": "Pagato",
    "cancelar.perPerson": "/ persona",
    "cancelar.totalRefund": "Totale da rimborsare",
    "cancelar.noRefund": "Nessun rimborso",
    "cancelar.reason.full": "Ingresso + menù",
    "cancelar.reason.menuOnly": "Solo il menù · l'ingresso non è rimborsabile",
    "cancelar.noRefundNote": "Puoi comunque annullare per liberare il tuo tavolo, ma secondo la politica di cancellazione (meno di 24 h prima della sessione) non c'è rimborso.",
    "cancelar.error.generic": "Impossibile annullare la prenotazione. Riprova più tardi.",
    "cancelar.confirm": "Conferma annullamento",
    "cancelar.confirming": "Annullamento…",
    "cancelar.policy.title": "Politica di cancellazione",
    "cancelar.cantCancel.title": "Questa prenotazione non può essere annullata online.",
    "cancelar.cantCancel.notPaid": "La prenotazione non risulta pagata.",
    "cancelar.cantCancel.past": "La sessione è già iniziata o è passata. Contatta il ristorante.",
    "cancelar.notFound": "Non abbiamo trovato la prenotazione.",
    "landing.hero.price": "Da 5€ + Cena",
    "landing.hero.subtitle": "Ascolta Jazz dal vivo e cena\nnel nostro club nella Manhattan\ndegli anni Venti.",
    "landing.hero.cta": "Scopri il programma",
    "landing.info.sessions": "SESSIONI",
    "landing.info.sessions.value": "19:00 - 21:00 - 23:00",
    "landing.info.duration": "DURATA",
    "landing.info.duration.value": "1h 45 min",
    "landing.info.includes": "INCLUDE",
    "landing.info.includes.value": "Concerto + Menù",
    "landing.button.reserve": "Prenota Jazz Nights",
    "landing.programming.title": "Programma",
    "landing.programming.artist.pending": "Da confermare",
    "landing.programming.photo.placeholder": "— foto —",
    "landing.howitworks.title": "Come funziona",
    "landing.howitworks.step1.title": "SCEGLI LA SESSIONE",
    "landing.howitworks.step1.description": "Seleziona l'orario che preferisci tra le nostre tre sessioni.",
    "landing.howitworks.step2.title": "SCEGLI LA POSIZIONE",
    "landing.howitworks.step2.description": "Scegli la tua zona preferita per vivere la tua esperienza.",
    "landing.howitworks.step3.title": "SELEZIONA IL TUO MENÙ",
    "landing.howitworks.step3.description": "Scopri la proposta gastronomica che abbiamo creato.",
    "landing.howitworks.step4.title": "GODITI LA SERATA",
    "landing.howitworks.step4.description": "Lasciati trasportare dal jazz, dalla gastronomia e dalla magia degli anni Venti.",
    "sesiones.personas.heading": "Quante persone siete?",
    "sesiones.personas.btn_remove_aria": "Togli una persona",
    "sesiones.personas.btn_add_aria": "Aggiungi una persona",
    "sesiones.personas.btn_continue": "Continua",
    "sesiones.fecha.heading": "Scegli la data",
    "sesiones.fecha.loading": "Caricamento del programma…",
    "sesiones.fecha.empty_state": "Non ci sono ancora sessioni in programma. Torna presto.",
    "sesiones.fecha.event_title": "Jazz Night a Manhattan",
    "sesiones.fecha.event_description": "Ascolta Jazz dal vivo e cena nel nostro club nella Manhattan degli anni Venti.",
    "sesiones.fecha.event_price": "Ingresso da 5€ + cena",
    "sesiones.fecha.btn_back": "‹ Indietro",
    "sesiones.fecha.btn_continue": "Continua",
    "sesiones.hora.heading": "Seleziona l'orario della sessione",
    "sesiones.hora.subtitle": "Seleziona l'orario che preferisci tra le nostre tre sessioni.",
    "sesiones.hora.session_type": "Concerto + cena",
    "sesiones.hora.event_price": "Ingresso da 5€ + cena",
    "sesiones.hora.btn_back": "‹ Indietro",
    "sesiones.hora.btn_continue": "Continua",
    "ubicacion.breadcrumb.personas": "{n} persone",
    "ubicacion.heading.title": "Scegli la tua posizione",
    "ubicacion.heading.subtitle": "Il prezzo dell'ingresso dipende dalla zona selezionata. I tavoli grigi non sono disponibili.",
    "ubicacion.loading.message": "Caricamento della pianta…",
    "ubicacion.back.button": "‹ Indietro",
    "ubicacion.cta.loading": "Prenotazione in corso…",
    "ubicacion.cta.ready": "Continua",
    "ubicacion.modal.title": "Prima di continuare",
    "ubicacion.modal.description": "Hai scelto un tavolo nel patio; questi tavoli si trovano dietro il palco, quindi la visibilità del concerto può essere limitata o nulla.",
    "ubicacion.modal.confirm_button": "Sì, continua",
    "ubicacion.modal.confirm_loading": "Prenotazione in corso…",
    "ubicacion.modal.cancel_button": "Voglio sceglierne un altro",
    "menu.step_heading": "Seleziona il tuo menù",
    "menu.step_subtitle": "L'esperienza Jazz Nights include ingresso e menù della cena per tutti i partecipanti.",
    "menu.error_invalid": "Seleziona un menù valido",
    "menu.loading": "Caricamento…",
    "menu.price_per_person": "€ / persona",
    "menu.course_mandatory": "Obbligatorio",
    "menu.course_shared": "Da condividere",
    "menu.course_drink_variant": "Bevanda + cocktail",
    "menu.course_label_entrantes": "Antipasti",
    "menu.course_label_principal": "Secondo",
    "menu.course_label_postres": "Dolci",
    "menu.course_label_bebida": "Bevanda",
    "menu.course_instruction_principal": "Scegli 1 secondo a persona",
    "menu.course_instruction_postre": "Scegli 1 dolce a persona",
    "menu.button_remove": "Togli {name}",
    "menu.button_add": "Aggiungi {name}",
    "menu.button_selected": "Menù selezionato",
    "menu.button_choose": "Scegli il {name}",
    "menu.button_back": "‹ Indietro",
    "menu.button_continue": "Continua al pagamento",
    "menu.error_incomplete_courses": "Scegli {seats} {course} in totale (ne hai {current})",
    "menu.error_save_failed": "Non è stato possibile salvare il menù",
    "menu.breadcrumb_party_size": "{n} persone",
    "pago.loading.label": "Caricamento della prenotazione…",
    "pago.revisar.heading": "CONTROLLA CHE SIA TUTTO CORRETTO",
    "pago.revisar.summary.personas": "Persone",
    "pago.revisar.summary.fecha": "Data",
    "pago.revisar.summary.hora_sesion": "Orario sessione",
    "pago.revisar.summary.entrada_concierto": "Ingresso concerto",
    "pago.revisar.summary.entrada_valor": "{price} / persona",
    "pago.revisar.summary.menu": "Menù",
    "pago.revisar.summary.menu_valor": "{name} · {price} / persona",
    "pago.revisar.summary.principales": "Secondi",
    "pago.revisar.summary.postres": "Dolci",
    "pago.revisar.recomendacion": "Ti consigliamo di arrivare tra i 15 e i 30 minuti prima dell'inizio dell'esperienza",
    "pago.revisar.cta": "Conferma le informazioni",
    "pago.confirmed.heading": "PRENOTAZIONE CONFERMATA!",
    "pago.confirmed.demo_note": "Modalità demo — il pagamento reale si attiva in produzione.",
    "pago.contacto.heading": "INFINE CI SERVE IL TUO CONTATTO",
    "pago.contacto.seccion_datos.titulo": "Dati di contatto",
    "pago.contacto.form.nombre_placeholder": "Nome e cognome*",
    "pago.contacto.form.email_placeholder": "Email*",
    "pago.contacto.form.telefono_placeholder": "Telefono*",
    "pago.contacto.form.comentarios_placeholder": "Commenti o allergie",
    "pago.contacto.seccion_condiciones.titulo": "Condizioni",
    "pago.contacto.condiciones.experiencia": "Ho letto che l'esperienza include ingresso e cena",
    "pago.contacto.condiciones.politicas": "Accetto il Trattamento dei Dati, l'Informativa sulla Privacy e la Politica di Cancellazione",
    "pago.contacto.condiciones.politicas_parte1": "Accetto il ",
    "pago.contacto.condiciones.politicas_parte2": "Trattamento dei Dati",
    "pago.contacto.condiciones.politicas_parte3": ", ",
    "pago.contacto.condiciones.politicas_parte4": "Informativa sulla Privacy",
    "pago.contacto.condiciones.politicas_parte5": " e ",
    "pago.contacto.condiciones.politicas_parte6": "Politica di Cancellazione",
    "pago.contacto.condiciones.comunicaciones": "Acconsento alla ricezione di comunicazioni del ristorante via e-mail e/o SMS a fini commerciali.",
    "pago.contacto.recomendacion": "Ti consigliamo di arrivare tra i 15 e i 30 minuti prima dell'inizio dell'esperienza",
    "pago.contacto.seccion_total.titulo": "Totale della prenotazione",
    "pago.contacto.total.entrada": "Ingresso",
    "pago.contacto.total.entrada_subtexto": "{price} × {n}",
    "pago.contacto.total.menu": "Menù",
    "pago.contacto.total.menu_subtexto": "{price} × {n}",
    "pago.contacto.total.total": "Totale",
    "pago.contacto.error_completos": "Completa nome, email e telefono per continuare.",
    "pago.contacto.error_condiciones": "Devi accettare le condizioni per continuare.",
    "pago.contacto.error_pago": "Errore nell'avvio del pagamento",
    "pago.contacto.volver": "‹ Indietro",
    "pago.contacto.cta": "Continua al pagamento",
    "pago.checkout.procesando": "Elaborazione in corso…",
    "pago.checkout.cta": "Paga",
    "pago.checkout.error_generico": "Errore nel pagamento",
    "politicaCancelacion.titulo": "Politica di cancellazione",
    "politicaCancelacion.contenido.encabezado": "Cancellazioni e modifiche",
    "politicaCancelacion.contenido.regla1": "Più di 48h prima della sessione: cancellazione gratuita e rimborso integrale (ingresso + menù).",
    "politicaCancelacion.contenido.regla2": "Tra 48h e 24h prima: viene rimborsato il menù; l'ingresso al concerto non è rimborsabile.",
    "politicaCancelacion.contenido.regla3": "Meno di 24h prima o mancata presentazione: nessun rimborso.",
    "politicaCancelacion.contenido.cambiosFecha": "Cambi di data senza costi fino a 48h prima della sessione, salvo disponibilità.",
    "politicaCancelacion.boton.volver": "‹ Indietro",
    "confirmacion.error.notFound": "Prenotazione non trovata.",
    "confirmacion.loading": "Caricamento della conferma…",
    "confirmacion.processing.label": "Elaborazione del pagamento",
    "confirmacion.processing.title": "Stiamo confermando la tua prenotazione",
    "confirmacion.processing.message": "Di solito ci vogliono pochi secondi. Non chiudere questa pagina.",
    "confirmacion.failed.label": "Pagamento non completato",
    "confirmacion.failed.title": "Non siamo riusciti a confermare la tua prenotazione",
    "confirmacion.failed.message": "Se pensi che si tratti di un errore, contatta il ristorante con il tuo riferimento: {referenceId}",
    "confirmacion.success.label": "Prenotazione confermata",
    "confirmacion.success.title": "Ti aspettiamo sabato",
    "confirmacion.details.label": "Dettagli",
    "confirmacion.details.artist": "Artista",
    "confirmacion.details.people": "Persone",
    "confirmacion.details.totalPaid": "Totale pagato",
    "confirmacion.details.reference": "Riferimento",
    "confirmacion.dishes.label": "Piatti scelti",
    "confirmacion.dishes.principal": "Secondo",
    "confirmacion.dishes.postre": "Dolce",
    "confirmacion.ticket.label": "Il tuo ingresso",
    "confirmacion.ticket.qrAlt": "QR della tua prenotazione",
    "confirmacion.ticket.instructions": "Mostra questo QR all'ingresso il giorno dello spettacolo.",
    "confirmacion.email.sent": "Ti abbiamo inviato i dettagli a {email}.",
    "layout.header.logo.aria_label": "Voltereta — home",
    "layout.footer.logo.aria_label": "Voltereta — home",
    "wizard.header.title": "Prenota la tua Jazz Night",
    "tablepicker.zone.salon": "Sala principale",
    "tablepicker.zone.patio": "Patio",
    "tablepicker.table.tooltip": "Tavolo {number} · {capacity} pax · {price} ingresso",
    "tablepicker.backdrop.escenario": "PALCO",
    "tablepicker.backdrop.tras_escenario": "DIETRO IL PALCO",
    "stepper.progress_label": "Avanzamento della prenotazione",
    "ubicacion.error.loading_tables": "Errore nel caricamento dei tavoli",
    "ubicacion.error.reserve_failed": "Impossibile prenotare il tavolo",
    "ubicacion.breadcrumb.table_prefix": "tavolo"
  }
};
